import { Injectable } from "@angular/core";
import { Http } from "@angular/http";
import { BaseProvider } from "../BaseProvider";
import {
    OrderResponseModel,
    LoginResponseModel,
    OrderRequestModel,
} from "../../_models/index";
import { Observable } from "rxjs/Observable";
import "rxjs/add/operator/map";
import { GlobalService } from "../../_global/global.service";
import {
    OtherDocumentRequest,
    createVirtualRequest,
} from "../../_models/order/OrderRequestModel";

@Injectable()
export class OrderService extends BaseProvider {
    getOrderStatusUrl = "orders/";
    getInsuranceOrdersUrl = "travelInsuranceGetOrders";
    getDepartmentsUrl = "cdp/departments";
    getOrdersUrl = "orders";
    getOrdersSnippetUrl = "orderSnippets";
    getOrdersShortSnippetUrl = "orderShortSnippets";
    getOrdersShortSnippetNewUrl = "orderShortSnippetsList";

    getOrderDetailsURL = "orders/##ORDERID##";
    getkycDetailsUrl = "kyc";
    postBulkOrdersURL = "ordersbulk";
    consludeRateURL = "orders/##ORDERID##/concluded";
    API_URL: any;
    postOrdersUrl =
    "consumers/##CONSUMERID##/orders?userId=##USERID##&partnerId=##PARTNERID##";
    getOrdersShortSnippetNewUrlForAgent =
    "orderShortSnippetsList?onlyPartnerOrders=true";

    baseProvider: BaseProvider;
    isFromCdp: boolean = false;

    constructor(
        private http: Http,
        private _gs: GlobalService,
    ) {
        super(http);
    }

    // Helper to switch prefix between 'gp' and 'cdp' based on isFromCdp flag
    private buildPrefixedUrl(path: string, isFromCdp: boolean = false) {
        const prefix = isFromCdp || this.isFromCdp ? "cdp" : "gp";
        // If path already starts with a slash, avoid double slash
        if (path.startsWith("/")) {
            return prefix + path;
        }
        return prefix + "/" + path;
    }

    calculateRates(
        product,
        currencyCode,
        issuerCode,
        currencyAmountRequired,
        sellType,
    ) {
        const endpoint = "rateCalculator";
        const params =
            `?product=${product}` +
            `&requiredCurrency=${currencyCode}` +
            `&issuerCode=${issuerCode}` +
            `&requiredAmount=${currencyAmountRequired}` +
            `&sellType=${sellType}`;

        return this.makeGetCall(endpoint + params);
    }

    getBranchesShort(partnrtId) {
        return this.makeGetCall("getBranchesByPartner?partnerId=" + partnrtId);
    }

    getUsersShort(banchId) {
        return this.makeGetCall("getUsersByBranch?branchId=" + banchId);
    }
    sendEmailLink(request) {
        return this.makePostCall("payments/pageLink", request);
    }

    getESimOrdersList() {
        return this.makeGetCall("getAllZetexaOrder");
    }
    updateESimOrderStatus(orderId, requestBody: any) {
        return this.makePatchCall(
            "UpdateZetexaOrderStatus/" + orderId,
            requestBody,
        );
    }
    getOrders() {
        return this.makeGetCall(
            this.getOrdersUrl + "?partnerId=" + this._gs.currentUser.partner.id,
        );
    }
    getSignedDocs() {
        return this.makeGetCall("doclocker/allSignedDocuments");
    }
    getPassportDetails(kit) {
        return this.makeGetCall(
            this.buildPrefixedUrl("passportDetails?kit=" + kit),
        );
    }
    getOrderDeliveryStatus(orderId) {
        return this.makeGetCall(
            this.getOrdersUrl + "/" + orderId + "/" + "delivery",
        );
    }
    getTransactions(kitId, fromDate, toDate) {
        return this.makeGetCall(
            this.buildPrefixedUrl(
                "getTransactions?kitId=" +
                kitId +
                "&fromDate=" +
                fromDate +
                "&toDate=" +
                toDate,
            ),
        );
    }
    // postCompleteCardRequest(id, promoCode, promoCodeId) {
    //     var reqBody = {}
    //     return this.makePostCall(this.buildPrefixedUrl('completeCardRequest?requestId=' + id + '&promoCode=' +promoCode + '&promoCodeId='+ promoCodeId), reqBody);
    // }

    getPartnersForAutoExpiry() {
        return this.makeGetCall("concludeDaysPartners");
    }

    postConcludeDays(request: any) {
        return this.makePatchCall("concludeDays", request);
    }

    getConcludeDays(partnerId) {
        return this.makeGetCall("concludeDays?partnerId=" + partnerId);
    }

    getIbrToggle() {
        return this.makeGetCall("ibrConfig");
    }

    updateIbrToggle(
        id: number,
        ibrToggle: boolean,
        isFlatServiceCharges?: boolean,
    ) {
        const queryParams = [];
        if (ibrToggle !== undefined) {
            queryParams.push(`ibrToggle=${ibrToggle}`);
        }
        if (isFlatServiceCharges !== undefined) {
            queryParams.push(`isFlatServiceCharges=${isFlatServiceCharges}`);
        }

        return this.makePatchCall(
            `ibrConfig/${id}/toggle?${queryParams.join("&")}`,
            {},
        );
    }

    postCompleteCardRequest(id, promoCode, promoCodeId) {
        let resourceURL = this.buildPrefixedUrl(
            `completeCardRequest?requestId=${id}`,
        );

        if (promoCode) {
            resourceURL +=
                `&promoCode=${promoCode}` +
                (promoCodeId != null ? "&promoCodeId=" + promoCodeId : "");
        }

        const reqBody = {}; // or your model
        return this.makePostCall(resourceURL, reqBody);
    }

    postCardOperation(requestId, entityType) {
        return this.makePostCall(
            this.buildPrefixedUrl(
                "updateOperationStatus?requestId=" +
                requestId +
                "&entityType=" +
                entityType,
            ),
            {},
        );
    }

    postCardIssuer(requestId, issuer) {
        return this.makePostCall(
            this.buildPrefixedUrl(
                "updateRequestIssuer?requestId=" + requestId + "&issuer=" + issuer,
            ),
            {},
        );
    }

    postEmbossedDetails(reqBody) {
        return this.makePostCall(
            this.buildPrefixedUrl("cardOperationUpdateEmbossing"),
            reqBody,
        );
    }
    postXplorerCardEditDetails(request) {
        return this.makePostCall(
            this.buildPrefixedUrl("updateGlobalPayExchangeCardRequest"),
            request,
        );
    }
    getNostroCharges(partnerId) {
        return this.makeGetCall("nostroCharges?partnerId=" + partnerId);
    }
    getServiceCharges(partnerId) {
        return this.makeGetCall("serviceCharges?partnerId=" + partnerId);
    }

    getXLDocs(fromDate, toDate) {
        return this.makeGetCall(
            "excelFormattingHistory?fromDate=" + fromDate + "&toDate=" + toDate,
        );
    }
    uploadxlDocs(orderRequest: any) {
        return this.makeUploadCall("excel/convert", orderRequest);
    }
    postCardRequestStatus(id, status) {
        let resourceURL = this.buildPrefixedUrl(
            `updateCardRequestStatus?id=${id}&status=${status}`,
        );

        const reqBody = {}; // or your model
        return this.makePostCall(resourceURL, reqBody);
    }

    getNetworkTransaction(kitId, fromDate, toDate) {
        return this.makeGetCall(
            this.buildPrefixedUrl(
                "getSuccessFailTransactions?kitId=" +
                kitId +
                "&fromDate=" +
                fromDate +
                "&toDate=" +
                toDate,
            ),
        );
    }
    getInitiate;

    postOrderDeliveryStatus(orderId, orderRequest: any) {
        return this.makeUploadCall(
            this.getOrdersUrl + "/" + orderId + "/" + "delivery",
            orderRequest,
        );

        // return this.makePostCall(this.getOrdersUrl + "/"+ orderId+"/"+"delivery",orderRequest);
    }
    getOrderInteractions(orderId) {
        return this.makeGetCall("getAllOrderInteractions?orderId=" + orderId);
    }
    postOrderInteraction(req) {
        return this.makePostCall("registerOrderInteractions", req);
    }
    getCardRequestList(fromDate, toDate, operation) {
        return this.makeGetCall(
            this.buildPrefixedUrl(
                "getAllCardRequest?from=" +
                fromDate +
                "&to=" +
                toDate +
                "&operation=" +
                operation +
                "&status=OPEN,FAILED",
            ),
        );
    }
    getAgentOrders(
        partnerId,
        uiChannel,
        productGroup,
        status,
        paymentStatus,
        startDate,
        endDate,
        branchId,
        userId,
        pageNumber,
        recordPerPage,
        searchKeyword,
        sortField,
        sortOrder,
        exportRecords,
    ) {
        let param =
            "&startDate=" +
            startDate +
            "&endDate=" +
            endDate +
            (partnerId != null ? "&partnerId=" + partnerId : "") +
            (uiChannel != -1 ? "&uiChannel=" + uiChannel : "") +
            (productGroup != -1 ? "&productGroup=" + productGroup : "") +
            (status != -1 ? "&status=" + status : "") +
            (paymentStatus != -1 ? "&paymentStatus=" + paymentStatus : "") +
            (branchId != -1 ? "&branchId=" + branchId : "") +
            (userId != -1 ? "&userId=" + userId : "") +
            (pageNumber != null ? "&pageNumber=" + pageNumber : "") +
            (recordPerPage != null ? "&recordPerPage=" + recordPerPage : "") +
            (searchKeyword != "" ? "&searchKeyword=" + searchKeyword : "") +
            (sortField != -1 ? "&sortField=" + sortField : "") +
            (sortOrder != -1 ? "&sortOrder=" + sortOrder : "") +
            (exportRecords != -1 ? "&exportRecords=" + exportRecords : "");
        return this.makeGetCall(this.getOrdersShortSnippetNewUrlForAgent + param);
        //return this.makeGetCall(this.getOrdersShortSnippetUrl + "?partnerId=" + partnerId);
    }
    getFPAASOrders(
        partnerId,
        productGroup,
        status,
        paymentStatus,
        startDate,
        endDate,
        branchId,
        userId,
        pageNumber,
        recordPerPage,
        searchKeyword,
        sortField,
        sortOrder,
        exportRecords,
    ) {
        let param =
            "?startDate=" +
            startDate +
            "&endDate=" +
            endDate +
            (partnerId != null ? "&partnerId=" + partnerId : "") +
            "&uiChannel=widget" +
            (productGroup != -1 ? "&productGroup=" + productGroup : "") +
            (status != -1 ? "&status=" + status : "") +
            (paymentStatus != -1 ? "&paymentStatus=" + paymentStatus : "") +
            (branchId != -1 ? "&branchId=" + branchId : "") +
            (userId != -1 ? "&userId=" + userId : "") +
            (pageNumber != null ? "&pageNumber=" + pageNumber : "") +
            (recordPerPage != null ? "&recordPerPage=" + recordPerPage : "") +
            (searchKeyword != "" ? "&searchKeyword=" + searchKeyword : "") +
            (sortField != -1 ? "&sortField=" + sortField : "") +
            (sortOrder != -1 ? "&sortOrder=" + sortOrder : "") +
            (exportRecords != -1 ? "&exportRecords=" + exportRecords : "");
        return this.makeGetCall(this.getOrdersShortSnippetNewUrl + param);
        //return this.makeGetCall(this.getOrdersShortSnippetUrl + "?partnerId=" + partnerId);
    }
    getCardRequestListStatus(fromDate, toDate, operation, status) {
        return this.makeGetCall(
            this.buildPrefixedUrl(
                "getAllCardRequest?from=" +
                fromDate +
                "&to=" +
                toDate +
                "&operation=" +
                operation +
                "&status=" +
                status,
            ),
        );
    }
    postCardRequest(requestBody) {
        return this.makePostCall(
            this.buildPrefixedUrl("cardOperation"),
            requestBody,
        );
    }
    getCardDetails(consumerId, kitId) {
        return this.makeGetCall(
            this.buildPrefixedUrl(
                "getFullCardWithCvv?id=" + consumerId + "&kitId=" + kitId,
            ),
        );
    }
    getCardBalance(id, kitId) {
        return this.makeGetCall(
            this.buildPrefixedUrl("getBalance?id=" + id + "&kitId=" + kitId),
        );
    }
    postCardStatusActions(reqBody) {
        return this.makePostCall(
            this.buildPrefixedUrl("lockUnlockAndBlockCard"),
            reqBody,
        );
    }
    postCardPreferences(reqBody) {
        return this.makePostCall(
            this.buildPrefixedUrl("updatePreference"),
            reqBody,
        );
    }
    postCardLimits(reqBody) {
        return this.makePostCall(this.buildPrefixedUrl("updateLimit"), reqBody);
    }
    postCardLimitsEnhance(reqBody) {
        return this.makePostCall(this.buildPrefixedUrl("enhanceLimit"), reqBody);
    }
    postCardPIN(reqBody) {
        return this.makePostCall(this.buildPrefixedUrl("updatePin"), reqBody);
    }
    postReplaceCard(reqBody) {
        return this.makePostCall(
            this.buildPrefixedUrl("admin/replaceCard"),
            reqBody,
        );
    }
    getAllCardDetails(searchType, searchTerm) {
        var reqBody = {};
        return this.makePostCall(
            this.buildPrefixedUrl(
                "fetchAllDetails?type=" + searchType + "&value=" + searchTerm,
            ),
            reqBody,
        );
    }
    getCardsBySearch(searchType, searchTerm, isFromCdp = false) {
        return this.makePostCall(
            this.buildPrefixedUrl(
                "searchFilter?type=" + searchType + "&value=" + searchTerm,
                isFromCdp,
            ),
            {},
        );
    }

    getAllCardData(kit) {
        return this.makeGetCall(this.buildPrefixedUrl("getCardRequest?kit=" + kit));
    }
    postCommunicationDetails(kitId, email, countryCode, mobile) {
        return this.makePostCall(
            this.buildPrefixedUrl(
                "updateCommunication?kit=" +
                kitId +
                "&email=" +
                email +
                "&countryCode=" +
                countryCode +
                "&mobile=" +
                mobile,
            ),
            {},
        );
    }
    getCardAuditTrail(kit) {
        return this.makeGetCall("cardAuditTrails?kitId=" + kit);
    }
    getCardAuditTrails(kit) {
        return this.makeGetCall("getGlobalPayCardAuditTrail?id=" + kit);
    }
    editCompletedOrder(orderId) {
        var reqBody = {};
        return this.makePatchCall(
            "orders/" + orderId + "/" + "openEditing",
            reqBody,
        );
    }
    redirectionData(mobile, channel, data) {
        return this.makePostCall(
            "wsfx/redirectionData?channel=" + channel + "&mobile=" + mobile,
            data,
        );
    }
    postPaidBy(orderId, PaidBy, remittanceBy, body) {
        return this.makePostCall(
            "credilaPaidBy?orderId=" +
            orderId +
            "&paidBy=" +
            PaidBy +
            "&remittanceBy=" +
            remittanceBy,
            body,
        );
    }
    getAllOrderLrsDetails(pan) {
        var resourceURL = "getAllOrderLrsDetails?pan=" + pan;
        return this.makeGetCall(resourceURL);
    }
    patchOrder(orderId, orderRequest: any) {
        return this.makePatchCall("orders" + "/" + orderId, orderRequest);
    }
    postDocumentSigning(response) {
        return this.makeUploadCall("doclocker/initiateDocumentSigning", response);
    }
    getColorCodeList(partnerId) {
        return this.makeGetCall("colorFilter?partnerId=" + partnerId);
    }
    getAd1Deals(
        startDate,
        endDate,
        branchId,
        orderType,
        currencyCode,
        coverType,
        dealStatus,
        remitter,
        bankType,
    ) {
        var url =
            "ad1Deals?" +
            "startDate=" +
            startDate +
            "&endDate=" +
            endDate +
            (branchId != -1 ? "&branchId=" + branchId : "") +
            (orderType != -1 ? "&orderType=" + orderType : "") +
            (currencyCode ? "&currencyCode=" + currencyCode : "") +
            (coverType != -1 ? "&coverType=" + coverType : "") +
            (remitter != -1 ? "&remitter=" + remitter : "") +
            (dealStatus != -1 ? "&dealStatus=" + dealStatus : "") +
            (bankType != -1 ? "&bankType=" + bankType : "");
        return this.makeGetCall(url);
    }
    patchDemapAd1Deal(dealId, reason) {
        return this.makePatchCall(
            "unmapAd1Cover?dealId=" + dealId + "&reason=" + reason,
            {},
        );
    }
    postCoverAd1Deal(dealId, reqBody) {
        return this.makePostCall("coverAd1Deal?dealIdCSV=" + dealId, reqBody);
    }
    postAd1SendToBAnk(orderIds) {
        var reqBody = {};
        return this.makePostCall("ad1/sendToBank?orderIdCSV=" + orderIds, reqBody);
    }
    postStatusAd1(orderId, status, message) {
        var reqBody = {};
        return this.makePostCall(
            "ad1/approveOrder?orderId=" +
            orderId +
            "&status=" +
            status +
            "&message=" +
            message,
            reqBody,
        );
    }
    getAd1BankCover(orderId) {
        return this.makeGetCall("ad1/generateBankCover?orderId=" + orderId);
    }
    postRemitTransactions(orderRequest: any) {
        return this.makePostCall("transactionStatus", orderRequest);
    }
    postRemit(orderRequest: any) {
        return this.makePostCall("remitNow", orderRequest);
    }
    postTransactionStatus(remitOrderResponse: any) {
        return this.makePostCall("fetchSwiftAdvice", remitOrderResponse);
    }
    postFetchSwift(orderRequest: any) {
        return this.makePostCall("transactionStatus", orderRequest);
    }
    sendCompleteOrderByEmail(orderId) {
        return this.makePostCall("orderCompletionLink/" + orderId, orderId);
    }

    getOrderSnippets() {
        return this.makeGetCall(
            this.getOrdersSnippetUrl +
            "?partnerId=" +
            this._gs.currentUser.partner.id,
        );
    }

    getOrderHandShake(orderId) {
        return this.makeGetCall("orderHandshake?orderId=" + orderId);
    }

    getOrderReverseFlow(orderId) {
        return this.makeGetCall("exchange/order/" + orderId);
    }
    addConsumerBene(requestModel) {
        return this.makePostCall("consumers/beneficiary", requestModel);
    }
    getOrderShortSnippets(orderStatus) {
        return this.makeGetCall(
            this.getOrdersShortSnippetUrl +
            "?partnerId=" +
            this._gs.currentUser.partner.id,
        );
    }
    quotationOrders(orderStatus) {
        return this.makeGetCall(
            this.getOrdersShortSnippetUrl +
            "?partnerId=" +
            this._gs.currentUser.partner.id +
            "?orderStatus=" +
            orderStatus,
        );
    }
    getCheckPanDetails(requestModel) {
        return this.makeGetCall("checkPanDetails" + "?pan=" + requestModel);
    }

    getExchangeDeals(startDate, endDate) {
        return this.makeGetCall(
            "getAllExchangeDeals?fromDate=" + startDate + "&toDate=" + endDate,
        );
    }
    createDeal(requestModel) {
        return this.makePostCall("createExchangeDeal", requestModel);
    }
    MapDealWithOrder(requestModel) {
        return this.makePostCall("mapDealToOrder", requestModel);
    }
    unMapDealWithOrder(dealId) {
        return this.makeGetCall("unmapDeal?dealId=" + dealId);
    }

    getOneExchangeDeal(dealId) {
        return this.makeGetCall("getOneExchangeDeal?dealId=" + dealId);
    }
    getOrderDeal(orderId) {
        return this.makeGetCall("getOrderDeal?orderId=" + orderId);
    }
    // // getOrderShortSnippets(orderStatus) {
    //     if (orderStatus == "") {
    //         return this.makeGetCall(
    //             this.getOrdersShortSnippetUrl +
    //             "?partnerId=" +
    //             this._gs.currentUser.partner.id
    //         );
    //     } else {
    //         return this.makeGetCall(
    //             this.getOrdersShortSnippetUrl +
    //             "?partnerId=" +
    //             this._gs.currentUser.partner.id +
    //             "&status=" +
    //             orderStatus
    //         );
    //     }
    // }
    getCustomerOrderShortSnippets(consumerId) {
        return this.makeGetCall(
            this.getOrdersShortSnippetUrl +
            "?consumerId=" +
            consumerId +
            "&partnerId=" +
            this._gs.currentUser.partner.id,
        );
    }
    getFilteredQuoteOrders(
        startDate,
        endDate,
        branchId,
        paymentStatus,
        sortOrder,
        exportRecords,
        colorCode,
        recordPerPage,
        pageNumber,
        sortField,
        searchKeyword,
    ) {
        var partnerId;
        var creationType;
        creationType = "CONSUMER_QUOTATION";
        if (partnerId == null) {
            partnerId = this._gs.currentUser.partner.id;
        }
        if (partnerId == -1) {
            partnerId = this._gs.currentUser.partner.id;
        }
        var url =
            "?partnerId=" +
            partnerId +
            "&creationType=" +
            creationType +
            "&startDate=" +
            startDate +
            "&endDate=" +
            endDate +
            (branchId != -1 ? "&branchId=" + branchId : "") +
            (paymentStatus != -1 ? "&paymentStatus=" + paymentStatus : "") +
            (sortOrder != -1 ? "&sortOrder=" + sortOrder : "") +
            (exportRecords != -1 ? "&exportRecords=" + exportRecords : "") +
            (colorCode != -1 ? "&colorCode=" + colorCode : "") +
            (recordPerPage != -1 ? "&recordPerPage=" + recordPerPage : "") +
            (pageNumber != -1 ? "&pageNumber=" + pageNumber : "") +
            (sortField != -1 ? "&sortField=" + sortField : "") +
            (searchKeyword != "" ? "&searchKeyword=" + searchKeyword : "");
        return this.makeGetCall(this.getOrdersShortSnippetNewUrl + url);
    }
    getPoonawalaQuoteOrders(
        startDate,
        endDate,
        branchId,
        paymentStatus,
        sortOrder,
        exportRecords,
        colorCode,
        recordPerPage,
        pageNumber,
        sortField,
        searchKeyword,
    ) {
        var partnerId;
        var creationType;
        creationType = "CONSUMER_QUOTATION";
        if (
            (partnerId == null || partnerId == -1) &&
            (this.API_URL === "https://api.wsfx.in/" ||
                this.API_URL === "https://api.wsfxglobalpay.com/")
        ) {
            partnerId = "p_3B7hHxy65DH";
        } else {
            partnerId = "p_2bAjPriRiTJ";
        }
        var url =
            "?partnerId=" +
            partnerId +
            "&creationType=" +
            creationType +
            "&startDate=" +
            startDate +
            "&endDate=" +
            endDate +
            (branchId != -1 ? "&branchId=" + branchId : "") +
            (paymentStatus != -1 ? "&paymentStatus=" + paymentStatus : "") +
            (sortOrder != -1 ? "&sortOrder=" + sortOrder : "") +
            (exportRecords != -1 ? "&exportRecords=" + exportRecords : "") +
            (colorCode != -1 ? "&colorCode=" + colorCode : "") +
            (recordPerPage != -1 ? "&recordPerPage=" + recordPerPage : "") +
            (pageNumber != -1 ? "&pageNumber=" + pageNumber : "") +
            (sortField != -1 ? "&sortField=" + sortField : "") +
            (searchKeyword != "" ? "&searchKeyword=" + searchKeyword : "");
        return this.makeGetCall(this.getOrdersShortSnippetNewUrl + url);
    }
    getIDPQuoteOrders(
        startDate,
        endDate,
        branchId,
        paymentStatus,
        sortOrder,
        exportRecords,
        colorCode,
        recordPerPage,
        pageNumber,
        sortField,
        searchKeyword,
    ) {
        var partnerId;
        var creationType;
        creationType = "CONSUMER_QUOTATION";
        if (
            (partnerId == null || partnerId == -1) &&
            (this.API_URL === "https://api.wsfx.in/" ||
                this.API_URL === "https://api.wsfxglobalpay.com/")
        ) {
            partnerId = "p_2qXaRmFs7g9";
        } else {
            partnerId = "p_2ZhmrMkhJGB";
        }
        var url =
            "?partnerId=" +
            partnerId +
            "&creationType=" +
            creationType +
            "&startDate=" +
            startDate +
            "&endDate=" +
            endDate +
            (branchId != -1 ? "&branchId=" + branchId : "") +
            (paymentStatus != -1 ? "&paymentStatus=" + paymentStatus : "") +
            (sortOrder != -1 ? "&sortOrder=" + sortOrder : "") +
            (exportRecords != -1 ? "&exportRecords=" + exportRecords : "") +
            (colorCode != -1 ? "&colorCode=" + colorCode : "") +
            (recordPerPage != -1 ? "&recordPerPage=" + recordPerPage : "") +
            (pageNumber != -1 ? "&pageNumber=" + pageNumber : "") +
            (sortField != -1 ? "&sortField=" + sortField : "") +
            (searchKeyword != "" ? "&searchKeyword=" + searchKeyword : "");
        return this.makeGetCall(this.getOrdersShortSnippetNewUrl + url);
    }
    getIDPOrders(
        startDate,
        endDate,
        branchId,
        paymentStatus,
        sortOrder,
        exportRecords,
        colorCode,
        recordPerPage,
        pageNumber,
        sortField,
        searchKeyword,
        status,
    ) {
        var partnerId;
        if (
            (partnerId == null || partnerId == -1) &&
            (this.API_URL === "https://api.wsfx.in/" ||
                this.API_URL === "https://api.wsfxglobalpay.com/")
        ) {
            partnerId = "p_2qXaRmFs7g9";
        } else {
            partnerId = "p_2ZhmrMkhJGB";
        }
        var url =
            "?partnerId=" +
            partnerId +
            "&startDate=" +
            startDate +
            "&endDate=" +
            endDate +
            (branchId != -1 ? "&branchId=" + branchId : "") +
            (paymentStatus != -1 ? "&paymentStatus=" + paymentStatus : "") +
            (sortOrder != -1 ? "&sortOrder=" + sortOrder : "") +
            (exportRecords != -1 ? "&exportRecords=" + exportRecords : "") +
            (colorCode != -1 ? "&colorCode=" + colorCode : "") +
            (recordPerPage != -1 ? "&recordPerPage=" + recordPerPage : "") +
            (pageNumber != -1 ? "&pageNumber=" + pageNumber : "") +
            (sortField != -1 ? "&sortField=" + sortField : "") +
            (searchKeyword != "" ? "&searchKeyword=" + searchKeyword : "") +
            (status != -1 ? "&status=" + status : "");
        return this.makeGetCall(this.getOrdersShortSnippetNewUrl + url);
    }
    getWalkInOrders(
        partnerId,
        uiChannel,
        productGroup,
        status,
        paymentStatus,
        startDate,
        endDate,
        branchId,
        userId,
        pageNumber,
        recordPerPage,
        searchKeyword,
        sortField,
        sortOrder,
        exportRecords,
    ) {
        let param =
            "?startDate=" +
            startDate +
            "&endDate=" +
            endDate +
            (partnerId != null ? "&partnerId=" + partnerId : "") +
            (uiChannel != -1 ? "&uiChannel=" + uiChannel : "") +
            (productGroup != -1 ? "&productGroup=" + productGroup : "") +
            (status != -1 ? "&status=" + status : "") +
            (paymentStatus != -1 ? "&paymentStatus=" + paymentStatus : "") +
            (branchId != -1 ? "&branchId=" + branchId : "") +
            (userId != -1 ? "&userId=" + userId : "") +
            (pageNumber != null ? "&pageNumber=" + pageNumber : "") +
            (recordPerPage != null ? "&recordPerPage=" + recordPerPage : "") +
            (searchKeyword != "" ? "&searchKeyword=" + searchKeyword : "") +
            (sortField != -1 ? "&sortField=" + sortField : "") +
            (sortOrder != -1 ? "&sortOrder=" + sortOrder : "") +
            (exportRecords != -1 ? "&exportRecords=" + exportRecords : "");
        return this.makeGetCall(this.getOrdersShortSnippetNewUrl + param);
        //return this.makeGetCall(this.getOrdersShortSnippetUrl + "?partnerId=" + partnerId);
    }
    getCredilaDataFromPAN(pan, isStudent) {
        return this.makeGetCall(
            "credilaConsumerData" + "?pan=" + pan + "&isStudent=" + isStudent,
        );
    }
    sendQuoteAgain(orderId) {
        return this.makeGetCall("sendQuoteAgain?orderId=" + orderId);
    }
    requestDeal(orderId) {
        return this.makeGetCall("requestDeal?orderId=" + orderId);
    }
    getRemittanceOrders(partnerId, productGroup) {
        return this.makeGetCall(
            this.getOrdersShortSnippetUrl +
            "?partnerId=" +
            partnerId +
            "&productGroup=" +
            productGroup,
        );
    }
    getfilteredOrdersNew(
        partnerId,
        uiChannel,
        productGroup,
        status,
        paymentStatus,
        startDate,
        endDate,
        branchId,
        userId,
        pageNumber,
        recordPerPage,
        searchKeyword,
        sortField,
        sortOrder,
        exportRecords,
    ) {
        if (partnerId == null || partnerId == -1) {
            partnerId = this._gs.currentUser.partner.id;
        }

        let param =
            "?startDate=" +
            startDate +
            "&endDate=" +
            endDate +
            (partnerId != null ? "&partnerId=" + partnerId : "") +
            (uiChannel != -1 ? "&uiChannel=" + uiChannel : "") +
            (productGroup != -1 ? "&productGroup=" + productGroup : "") +
            (status != -1 ? "&status=" + status : "") +
            (paymentStatus != -1 ? "&paymentStatus=" + paymentStatus : "") +
            (branchId != -1 ? "&branchId=" + branchId : "") +
            (userId != -1 ? "&userId=" + userId : "") +
            (pageNumber != null ? "&pageNumber=" + pageNumber : "") +
            (recordPerPage != null ? "&recordPerPage=" + recordPerPage : "") +
            (searchKeyword != "" ? "&searchKeyword=" + searchKeyword : "") +
            (sortField != -1 ? "&sortField=" + sortField : "") +
            (exportRecords != -1 ? "&exportRecords=" + exportRecords : "");

        return this.makeGetCall(this.getOrdersShortSnippetNewUrl + param);
    }

    getFilteredOrders(
        partnerId,
        uiChannel,
        productGroup,
        status,
        paymentStatus,
        startDate,
        endDate,
        branchId,
        userId,
    ) {
        if (partnerId == null) {
            partnerId = this._gs.currentUser.partner.id;
        }
        if (partnerId == -1) {
            partnerId = this._gs.currentUser.partner.id;
        }

        if (
            productGroup != -1 &&
            status != -1 &&
            branchId != -1 &&
            uiChannel != -1 &&
            userId != -1
        ) {
            const url: string =
                this.getOrdersShortSnippetUrl +
                "?partnerId=" +
                partnerId +
                "&productGroup=" +
                productGroup +
                "&status=" +
                status +
                "&branchId=" +
                branchId +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate +
                "&userId=" +
                userId +
                "&uiChannel=" +
                uiChannel;
            return this.makeGetCall(url);
        }
        if (
            productGroup != -1 &&
            paymentStatus != -1 &&
            branchId != -1 &&
            uiChannel != -1 &&
            userId != -1
        ) {
            const url: string =
                this.getOrdersShortSnippetUrl +
                "?partnerId=" +
                partnerId +
                "&productGroup=" +
                productGroup +
                "&paymentStatus=" +
                paymentStatus +
                "&branchId=" +
                branchId +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate +
                "&userId=" +
                userId +
                "&uiChannel=" +
                uiChannel;
            return this.makeGetCall(url);
        }

        if (
            userId != -1 &&
            branchId != -1 &&
            uiChannel != -1 &&
            productGroup != -1
        ) {
            const url: string =
                this.getOrdersShortSnippetUrl +
                "?partnerId=" +
                partnerId +
                "&userId=" +
                userId +
                "&branchId=" +
                branchId +
                "&uiChannel=" +
                uiChannel +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate +
                "&productGroup=" +
                productGroup;
            return this.makeGetCall(url);
        }

        if (userId != -1 && branchId != -1 && uiChannel != -1 && status != -1) {
            const url: string =
                this.getOrdersShortSnippetUrl +
                "?partnerId=" +
                partnerId +
                "&userId=" +
                userId +
                "&branchId=" +
                branchId +
                "&uiChannel=" +
                uiChannel +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate +
                "&status=" +
                status;
            return this.makeGetCall(url);
        }

        if (
            userId != -1 &&
            branchId != -1 &&
            uiChannel != -1 &&
            paymentStatus != -1
        ) {
            const url: string =
                this.getOrdersShortSnippetUrl +
                "?partnerId=" +
                partnerId +
                "&userId=" +
                userId +
                "&branchId=" +
                branchId +
                "&uiChannel=" +
                uiChannel +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate +
                "&paymentStatus=" +
                paymentStatus;
            return this.makeGetCall(url);
        }

        if (userId != -1 && branchId != -1 && productGroup != -1 && status != -1) {
            const url: string =
                this.getOrdersShortSnippetUrl +
                "?partnerId=" +
                partnerId +
                "&userId=" +
                userId +
                "&branchId=" +
                branchId +
                "&productGroup=" +
                productGroup +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate +
                "&status=" +
                status;
            return this.makeGetCall(url);
        } else if (
            userId != -1 &&
            branchId != -1 &&
            productGroup != -1 &&
            paymentStatus != -1
        ) {
            const url: string =
                this.getOrdersShortSnippetUrl +
                "?partnerId=" +
                partnerId +
                "&userId=" +
                userId +
                "&branchId=" +
                branchId +
                "&productGroup=" +
                productGroup +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate +
                "&paymentStatus=" +
                paymentStatus;
            return this.makeGetCall(url);
        } else if (status != -1 && branchId != -1 && uiChannel != -1) {
            const url: string =
                this.getOrdersShortSnippetUrl +
                "?partnerId=" +
                partnerId +
                "&status=" +
                status +
                "&branchId=" +
                branchId +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate +
                "&uiChannel=" +
                uiChannel;
            return this.makeGetCall(url);
        } else if (userId != -1 && branchId != -1 && uiChannel != -1) {
            const url: string =
                this.getOrdersShortSnippetUrl +
                "?partnerId=" +
                partnerId +
                "&userId=" +
                userId +
                "&branchId=" +
                branchId +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate +
                "&uiChannel=" +
                uiChannel;
            return this.makeGetCall(url);
        } else if (userId != -1 && branchId != -1 && productGroup != -1) {
            const url: string =
                this.getOrdersShortSnippetUrl +
                "?partnerId=" +
                partnerId +
                "&userId=" +
                userId +
                "&branchId=" +
                branchId +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate +
                "&productGroup=" +
                productGroup;
            return this.makeGetCall(url);
        } else if (userId != -1 && branchId != -1 && status != -1) {
            const url: string =
                this.getOrdersShortSnippetUrl +
                "?partnerId=" +
                partnerId +
                "&userId=" +
                userId +
                "&branchId=" +
                branchId +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate +
                "&status=" +
                status;
            return this.makeGetCall(url);
        } else if (userId != -1 && branchId != -1 && paymentStatus != -1) {
            const url: string =
                this.getOrdersShortSnippetUrl +
                "?partnerId=" +
                partnerId +
                "&userId=" +
                userId +
                "&branchId=" +
                branchId +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate +
                "&paymentStatus=" +
                paymentStatus;
            return this.makeGetCall(url);
        } else if (userId != -1 && uiChannel != -1 && productGroup != -1) {
            const url: string =
                this.getOrdersShortSnippetUrl +
                "?partnerId=" +
                partnerId +
                "&userId=" +
                userId +
                "&uiChannel=" +
                uiChannel +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate +
                "&productGroup=" +
                productGroup;
            return this.makeGetCall(url);
        } else if (productGroup != -1 && branchId != -1 && uiChannel != -1) {
            const url: string =
                this.getOrdersShortSnippetUrl +
                "?partnerId=" +
                partnerId +
                "&productGroup=" +
                productGroup +
                "&branchId=" +
                branchId +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate +
                "&uiChannel=" +
                uiChannel;
            return this.makeGetCall(url);
        } else if (productGroup != -1 && status != -1 && uiChannel != -1) {
            const url: string =
                this.getOrdersShortSnippetUrl +
                "?partnerId=" +
                partnerId +
                "&productGroup=" +
                productGroup +
                "&status=" +
                status +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate +
                "&uiChannel=" +
                uiChannel;
            return this.makeGetCall(url);
        } else if (productGroup != -1 && paymentStatus != -1 && uiChannel != -1) {
            const url: string =
                this.getOrdersShortSnippetUrl +
                "?partnerId=" +
                partnerId +
                "&productGroup=" +
                productGroup +
                "&paymentStatus=" +
                paymentStatus +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate +
                "&uiChannel=" +
                uiChannel;
            return this.makeGetCall(url);
        } else if (productGroup != -1 && status != -1) {
            const url: string =
                this.getOrdersShortSnippetUrl +
                "?partnerId=" +
                partnerId +
                "&productGroup=" +
                productGroup +
                "&status=" +
                status +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate;
            return this.makeGetCall(url);
        } else if (paymentStatus != -1 && status != -1) {
            const url: string =
                this.getOrdersShortSnippetUrl +
                "?partnerId=" +
                partnerId +
                "&paymentStatus=" +
                paymentStatus +
                "&status=" +
                status +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate;
            return this.makeGetCall(url);
        } else if (productGroup != -1 && paymentStatus != -1) {
            const url: string =
                this.getOrdersShortSnippetUrl +
                "?partnerId=" +
                partnerId +
                "&productGroup=" +
                productGroup +
                "&paymentStatus=" +
                paymentStatus +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate;
            return this.makeGetCall(url);
        } else if (productGroup != -1 && branchId != -1) {
            const url: string =
                this.getOrdersShortSnippetUrl +
                "?partnerId=" +
                partnerId +
                "&productGroup=" +
                productGroup +
                "&branchId=" +
                branchId +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate;
            return this.makeGetCall(url);
        } else if (productGroup != -1 && uiChannel != -1) {
            const url: string =
                this.getOrdersShortSnippetUrl +
                "?partnerId=" +
                partnerId +
                "&productGroup=" +
                productGroup +
                "&uiChannel=" +
                uiChannel +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate;
            return this.makeGetCall(url);
        } else if (status != -1 && branchId != -1) {
            const url: string =
                this.getOrdersShortSnippetUrl +
                "?partnerId=" +
                partnerId +
                "&status=" +
                status +
                "&branchId=" +
                branchId +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate;
            return this.makeGetCall(url);
        } else if (paymentStatus != -1 && branchId != -1) {
            const url: string =
                this.getOrdersShortSnippetUrl +
                "?partnerId=" +
                partnerId +
                "&paymentStatus=" +
                paymentStatus +
                "&branchId=" +
                branchId +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate;
            return this.makeGetCall(url);
        } else if (status != -1 && uiChannel != -1) {
            const url: string =
                this.getOrdersShortSnippetUrl +
                "?partnerId=" +
                partnerId +
                "&status=" +
                status +
                "&uiChannel=" +
                uiChannel +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate;
            return this.makeGetCall(url);
        } else if (paymentStatus != -1 && uiChannel != -1) {
            const url: string =
                this.getOrdersShortSnippetUrl +
                "?partnerId=" +
                partnerId +
                "&paymentStatus=" +
                paymentStatus +
                "&uiChannel=" +
                uiChannel +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate;
            return this.makeGetCall(url);
        } else if (userId != -1 && uiChannel != -1) {
            const url: string =
                this.getOrdersShortSnippetUrl +
                "?partnerId=" +
                partnerId +
                "&userId=" +
                userId +
                "&uiChannel=" +
                uiChannel +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate;
            return this.makeGetCall(url);
        } else if (userId != -1 && productGroup != -1) {
            const url: string =
                this.getOrdersShortSnippetUrl +
                "?partnerId=" +
                partnerId +
                "&userId=" +
                userId +
                "&productGroup=" +
                productGroup +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate;
            return this.makeGetCall(url);
        } else if (userId != -1 && branchId != -1) {
            const url: string =
                this.getOrdersShortSnippetUrl +
                "?partnerId=" +
                partnerId +
                "&userId=" +
                userId +
                "&branchId=" +
                branchId +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate;
            return this.makeGetCall(url);
        } else if (userId != -1 && status != -1) {
            const url: string =
                this.getOrdersShortSnippetUrl +
                "?partnerId=" +
                partnerId +
                "&userId=" +
                userId +
                "&status=" +
                status +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate;
            return this.makeGetCall(url);
        } else if (userId != -1 && paymentStatus != -1) {
            const url: string =
                this.getOrdersShortSnippetUrl +
                "?partnerId=" +
                partnerId +
                "&userId=" +
                userId +
                "&paymentStatus=" +
                paymentStatus +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate;
            return this.makeGetCall(url);
        } else if (branchId != -1 && uiChannel != -1) {
            const url: string =
                this.getOrdersShortSnippetUrl +
                "?partnerId=" +
                partnerId +
                "&branchId=" +
                branchId +
                "&uiChannel=" +
                uiChannel +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate;
            return this.makeGetCall(url);
        } else if (productGroup != -1) {
            const url: string =
                this.getOrdersShortSnippetUrl +
                "?partnerId=" +
                partnerId +
                "&productGroup=" +
                productGroup +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate;
            return this.makeGetCall(url);
        } else if (uiChannel != -1) {
            const url: string =
                this.getOrdersShortSnippetUrl +
                "?partnerId=" +
                partnerId +
                "&uiChannel=" +
                uiChannel +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate;
            return this.makeGetCall(url);
        } else if (status != -1) {
            const url: string =
                this.getOrdersShortSnippetUrl +
                "?partnerId=" +
                partnerId +
                "&status=" +
                status +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate;
            return this.makeGetCall(url);
        } else if (userId != -1) {
            const url: string =
                this.getOrdersShortSnippetUrl +
                "?partnerId=" +
                partnerId +
                "&userId=" +
                userId +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate;
            return this.makeGetCall(url);
        } else if (branchId != -1) {
            const url: string =
                this.getOrdersShortSnippetUrl +
                "?partnerId=" +
                partnerId +
                "&branchId=" +
                branchId +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate;
            return this.makeGetCall(url);
        } else if (paymentStatus != -1) {
            const url: string =
                this.getOrdersShortSnippetUrl +
                "?partnerId=" +
                partnerId +
                "&paymentStatus=" +
                paymentStatus +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate;
            return this.makeGetCall(url);
        } else {
            const url: string =
                this.getOrdersShortSnippetUrl +
                "?partnerId=" +
                partnerId +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate;
            return this.makeGetCall(url);
        }
    }
    getFilteredConsumerOrders(
        partnerId,
        uiChannel,
        productGroup,
        status,
        paymentStatus,
        startDate,
        endDate,
        branchId,
        userId,
    ) {
        if (partnerId == null) {
            partnerId = this._gs.currentUser.partner.id;
        }
        if (partnerId == -1) {
            partnerId = this._gs.currentUser.partner.id;
        }

        if (
            productGroup != -1 &&
            status != -1 &&
            branchId != -1 &&
            uiChannel != -1 &&
            userId != -1
        ) {
            const url: string =
                this.getOrdersShortSnippetUrl +
                "?partnerId=" +
                partnerId +
                "&productGroup=" +
                productGroup +
                "&status=" +
                status +
                "&branchId=" +
                branchId +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate +
                "&userId=" +
                userId +
                "&uiChannel=" +
                uiChannel +
                "&orderPortal=" +
                "CONSUMER";
            return this.makeGetCall(url);
        }
        if (
            productGroup != -1 &&
            paymentStatus != -1 &&
            branchId != -1 &&
            uiChannel != -1 &&
            userId != -1
        ) {
            const url: string =
                this.getOrdersShortSnippetUrl +
                "?partnerId=" +
                partnerId +
                "&productGroup=" +
                productGroup +
                "&paymentStatus=" +
                paymentStatus +
                "&branchId=" +
                branchId +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate +
                "&userId=" +
                userId +
                "&uiChannel=" +
                uiChannel +
                "&orderPortal=" +
                "CONSUMER";
            return this.makeGetCall(url);
        }

        if (
            userId != -1 &&
            branchId != -1 &&
            uiChannel != -1 &&
            productGroup != -1
        ) {
            const url: string =
                this.getOrdersShortSnippetUrl +
                "?partnerId=" +
                partnerId +
                "&userId=" +
                userId +
                "&branchId=" +
                branchId +
                "&uiChannel=" +
                uiChannel +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate +
                "&productGroup=" +
                productGroup +
                "&orderPortal=" +
                "CONSUMER";
            return this.makeGetCall(url);
        }

        if (userId != -1 && branchId != -1 && uiChannel != -1 && status != -1) {
            const url: string =
                this.getOrdersShortSnippetUrl +
                "?partnerId=" +
                partnerId +
                "&userId=" +
                userId +
                "&branchId=" +
                branchId +
                "&uiChannel=" +
                uiChannel +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate +
                "&status=" +
                status +
                "&orderPortal=" +
                "CONSUMER";
            return this.makeGetCall(url);
        }

        if (
            userId != -1 &&
            branchId != -1 &&
            uiChannel != -1 &&
            paymentStatus != -1
        ) {
            const url: string =
                this.getOrdersShortSnippetUrl +
                "?partnerId=" +
                partnerId +
                "&userId=" +
                userId +
                "&branchId=" +
                branchId +
                "&uiChannel=" +
                uiChannel +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate +
                "&paymentStatus=" +
                paymentStatus +
                "&orderPortal=" +
                "CONSUMER";
            return this.makeGetCall(url);
        }

        if (userId != -1 && branchId != -1 && productGroup != -1 && status != -1) {
            const url: string =
                this.getOrdersShortSnippetUrl +
                "?partnerId=" +
                partnerId +
                "&userId=" +
                userId +
                "&branchId=" +
                branchId +
                "&productGroup=" +
                productGroup +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate +
                "&status=" +
                status +
                "&orderPortal=" +
                "CONSUMER";
            return this.makeGetCall(url);
        } else if (
            userId != -1 &&
            branchId != -1 &&
            productGroup != -1 &&
            paymentStatus != -1
        ) {
            const url: string =
                this.getOrdersShortSnippetUrl +
                "?partnerId=" +
                partnerId +
                "&userId=" +
                userId +
                "&branchId=" +
                branchId +
                "&productGroup=" +
                productGroup +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate +
                "&paymentStatus=" +
                paymentStatus +
                "&orderPortal=" +
                "CONSUMER";
            return this.makeGetCall(url);
        } else if (status != -1 && branchId != -1 && uiChannel != -1) {
            const url: string =
                this.getOrdersShortSnippetUrl +
                "?partnerId=" +
                partnerId +
                "&status=" +
                status +
                "&branchId=" +
                branchId +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate +
                "&uiChannel=" +
                uiChannel +
                "&orderPortal=" +
                "CONSUMER";
            return this.makeGetCall(url);
        } else if (userId != -1 && branchId != -1 && uiChannel != -1) {
            const url: string =
                this.getOrdersShortSnippetUrl +
                "?partnerId=" +
                partnerId +
                "&userId=" +
                userId +
                "&branchId=" +
                branchId +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate +
                "&uiChannel=" +
                uiChannel +
                "&orderPortal=" +
                "CONSUMER";
            return this.makeGetCall(url);
        } else if (userId != -1 && branchId != -1 && productGroup != -1) {
            const url: string =
                this.getOrdersShortSnippetUrl +
                "?partnerId=" +
                partnerId +
                "&userId=" +
                userId +
                "&branchId=" +
                branchId +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate +
                "&productGroup=" +
                productGroup +
                "&orderPortal=" +
                "CONSUMER";
            return this.makeGetCall(url);
        } else if (userId != -1 && branchId != -1 && status != -1) {
            const url: string =
                this.getOrdersShortSnippetUrl +
                "?partnerId=" +
                partnerId +
                "&userId=" +
                userId +
                "&branchId=" +
                branchId +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate +
                "&status=" +
                status +
                "&orderPortal=" +
                "CONSUMER";
            return this.makeGetCall(url);
        } else if (userId != -1 && branchId != -1 && paymentStatus != -1) {
            const url: string =
                this.getOrdersShortSnippetUrl +
                "?partnerId=" +
                partnerId +
                "&userId=" +
                userId +
                "&branchId=" +
                branchId +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate +
                "&paymentStatus=" +
                paymentStatus +
                "&orderPortal=" +
                "CONSUMER";
            return this.makeGetCall(url);
        } else if (userId != -1 && uiChannel != -1 && productGroup != -1) {
            const url: string =
                this.getOrdersShortSnippetUrl +
                "?partnerId=" +
                partnerId +
                "&userId=" +
                userId +
                "&uiChannel=" +
                uiChannel +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate +
                "&productGroup=" +
                productGroup +
                "&orderPortal=" +
                "CONSUMER";
            return this.makeGetCall(url);
        } else if (productGroup != -1 && branchId != -1 && uiChannel != -1) {
            const url: string =
                this.getOrdersShortSnippetUrl +
                "?partnerId=" +
                partnerId +
                "&productGroup=" +
                productGroup +
                "&branchId=" +
                branchId +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate +
                "&uiChannel=" +
                uiChannel +
                "&orderPortal=" +
                "CONSUMER";
            return this.makeGetCall(url);
        } else if (productGroup != -1 && status != -1 && uiChannel != -1) {
            const url: string =
                this.getOrdersShortSnippetUrl +
                "?partnerId=" +
                partnerId +
                "&productGroup=" +
                productGroup +
                "&status=" +
                status +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate +
                "&uiChannel=" +
                uiChannel +
                "&orderPortal=" +
                "CONSUMER";
            return this.makeGetCall(url);
        } else if (productGroup != -1 && paymentStatus != -1 && uiChannel != -1) {
            const url: string =
                this.getOrdersShortSnippetUrl +
                "?partnerId=" +
                partnerId +
                "&productGroup=" +
                productGroup +
                "&paymentStatus=" +
                paymentStatus +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate +
                "&uiChannel=" +
                uiChannel +
                "&orderPortal=" +
                "CONSUMER";
            return this.makeGetCall(url);
        } else if (productGroup != -1 && status != -1) {
            const url: string =
                this.getOrdersShortSnippetUrl +
                "?partnerId=" +
                partnerId +
                "&productGroup=" +
                productGroup +
                "&status=" +
                status +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate +
                "&orderPortal=" +
                "CONSUMER";
            return this.makeGetCall(url);
        } else if (paymentStatus != -1 && status != -1) {
            const url: string =
                this.getOrdersShortSnippetUrl +
                "?partnerId=" +
                partnerId +
                "&paymentStatus=" +
                paymentStatus +
                "&status=" +
                status +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate +
                "&orderPortal=" +
                "CONSUMER";
            return this.makeGetCall(url);
        } else if (productGroup != -1 && paymentStatus != -1) {
            const url: string =
                this.getOrdersShortSnippetUrl +
                "?partnerId=" +
                partnerId +
                "&productGroup=" +
                productGroup +
                "&paymentStatus=" +
                paymentStatus +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate +
                "&orderPortal=" +
                "CONSUMER";
            return this.makeGetCall(url);
        } else if (productGroup != -1 && branchId != -1) {
            const url: string =
                this.getOrdersShortSnippetUrl +
                "?partnerId=" +
                partnerId +
                "&productGroup=" +
                productGroup +
                "&branchId=" +
                branchId +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate +
                "&orderPortal=" +
                "CONSUMER";
            return this.makeGetCall(url);
        } else if (productGroup != -1 && uiChannel != -1) {
            const url: string =
                this.getOrdersShortSnippetUrl +
                "?partnerId=" +
                partnerId +
                "&productGroup=" +
                productGroup +
                "&uiChannel=" +
                uiChannel +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate +
                "&orderPortal=" +
                "CONSUMER";
            return this.makeGetCall(url);
        } else if (status != -1 && branchId != -1) {
            const url: string =
                this.getOrdersShortSnippetUrl +
                "?partnerId=" +
                partnerId +
                "&status=" +
                status +
                "&branchId=" +
                branchId +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate +
                "&orderPortal=" +
                "CONSUMER";
            return this.makeGetCall(url);
        } else if (paymentStatus != -1 && branchId != -1) {
            const url: string =
                this.getOrdersShortSnippetUrl +
                "?partnerId=" +
                partnerId +
                "&paymentStatus=" +
                paymentStatus +
                "&branchId=" +
                branchId +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate +
                "&orderPortal=" +
                "CONSUMER";
            return this.makeGetCall(url);
        } else if (status != -1 && uiChannel != -1) {
            const url: string =
                this.getOrdersShortSnippetUrl +
                "?partnerId=" +
                partnerId +
                "&status=" +
                status +
                "&uiChannel=" +
                uiChannel +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate +
                "&orderPortal=" +
                "CONSUMER";
            return this.makeGetCall(url);
        } else if (paymentStatus != -1 && uiChannel != -1) {
            const url: string =
                this.getOrdersShortSnippetUrl +
                "?partnerId=" +
                partnerId +
                "&paymentStatus=" +
                paymentStatus +
                "&uiChannel=" +
                uiChannel +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate +
                "&orderPortal=" +
                "CONSUMER";
            return this.makeGetCall(url);
        } else if (userId != -1 && uiChannel != -1) {
            const url: string =
                this.getOrdersShortSnippetUrl +
                "?partnerId=" +
                partnerId +
                "&userId=" +
                userId +
                "&uiChannel=" +
                uiChannel +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate +
                "&orderPortal=" +
                "CONSUMER";
            return this.makeGetCall(url);
        } else if (userId != -1 && productGroup != -1) {
            const url: string =
                this.getOrdersShortSnippetUrl +
                "?partnerId=" +
                partnerId +
                "&userId=" +
                userId +
                "&productGroup=" +
                productGroup +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate +
                "&orderPortal=" +
                "CONSUMER";
            return this.makeGetCall(url);
        } else if (userId != -1 && branchId != -1) {
            const url: string =
                this.getOrdersShortSnippetUrl +
                "?partnerId=" +
                partnerId +
                "&userId=" +
                userId +
                "&branchId=" +
                branchId +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate +
                "&orderPortal=" +
                "CONSUMER";
            return this.makeGetCall(url);
        } else if (userId != -1 && status != -1) {
            const url: string =
                this.getOrdersShortSnippetUrl +
                "?partnerId=" +
                partnerId +
                "&userId=" +
                userId +
                "&status=" +
                status +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate +
                "&orderPortal=" +
                "CONSUMER";
            return this.makeGetCall(url);
        } else if (userId != -1 && paymentStatus != -1) {
            const url: string =
                this.getOrdersShortSnippetUrl +
                "?partnerId=" +
                partnerId +
                "&userId=" +
                userId +
                "&paymentStatus=" +
                paymentStatus +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate +
                "&orderPortal=" +
                "CONSUMER";
            return this.makeGetCall(url);
        } else if (branchId != -1 && uiChannel != -1) {
            const url: string =
                this.getOrdersShortSnippetUrl +
                "?partnerId=" +
                partnerId +
                "&branchId=" +
                branchId +
                "&uiChannel=" +
                uiChannel +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate +
                "&orderPortal=" +
                "CONSUMER";
            return this.makeGetCall(url);
        } else if (productGroup != -1) {
            const url: string =
                this.getOrdersShortSnippetUrl +
                "?partnerId=" +
                partnerId +
                "&productGroup=" +
                productGroup +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate +
                "&orderPortal=" +
                "CONSUMER";
            return this.makeGetCall(url);
        } else if (uiChannel != -1) {
            const url: string =
                this.getOrdersShortSnippetUrl +
                "?partnerId=" +
                partnerId +
                "&uiChannel=" +
                uiChannel +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate +
                "&orderPortal=" +
                "CONSUMER";
            return this.makeGetCall(url);
        } else if (status != -1) {
            const url: string =
                this.getOrdersShortSnippetUrl +
                "?partnerId=" +
                partnerId +
                "&status=" +
                status +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate +
                "&orderPortal=" +
                "CONSUMER";
            return this.makeGetCall(url);
        } else if (userId != -1) {
            const url: string =
                this.getOrdersShortSnippetUrl +
                "?partnerId=" +
                partnerId +
                "&userId=" +
                userId +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate +
                "&orderPortal=" +
                "CONSUMER";
            return this.makeGetCall(url);
        } else if (branchId != -1) {
            const url: string =
                this.getOrdersShortSnippetUrl +
                "?partnerId=" +
                partnerId +
                "&branchId=" +
                branchId +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate +
                "&orderPortal=" +
                "CONSUMER";
            return this.makeGetCall(url);
        } else if (paymentStatus != -1) {
            const url: string =
                this.getOrdersShortSnippetUrl +
                "?partnerId=" +
                partnerId +
                "&paymentStatus=" +
                paymentStatus +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate +
                "&orderPortal=" +
                "CONSUMER";
            return this.makeGetCall(url);
        } else {
            const url: string =
                this.getOrdersShortSnippetUrl +
                "?partnerId=" +
                partnerId +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate +
                "&orderPortal=" +
                "CONSUMER";
            return this.makeGetCall(url);
        }
    }

    getFilteredConsumerOrdersPagination(
        partnerId,
        uiChannel,
        productGroup,
        status,
        paymentStatus,
        startDate,
        endDate,
        branchId,
        userId,
        pageNumber,
        recordPerPage,
        searchKeyword,
        sortField,
        sortOrder,
        exportRecords,
    ) {
        if (partnerId == null || partnerId == -1) {
            partnerId = this._gs.currentUser.partner.id;
        }

        let param =
            "?startDate=" +
            startDate +
            "&endDate=" +
            endDate +
            "&orderPortal=" +
            "CONSUMER" +
            (partnerId != null ? "&partnerId=" + partnerId : "") +
            (uiChannel != -1 ? "&uiChannel=" + uiChannel : "") +
            (productGroup != -1 ? "&productGroup=" + productGroup : "") +
            (status != -1 ? "&status=" + status : "") +
            (paymentStatus != -1 ? "&paymentStatus=" + paymentStatus : "") +
            (branchId != -1 ? "&branchId=" + branchId : "") +
            (userId != -1 ? "&userId=" + userId : "") +
            (pageNumber != null ? "&pageNumber=" + pageNumber : "") +
            (recordPerPage != null ? "&recordPerPage=" + recordPerPage : "") +
            (searchKeyword != "" ? "&searchKeyword=" + searchKeyword : "") +
            (sortField != -1 ? "&sortField=" + sortField : "") +
            (sortOrder != -1 ? "&sortOrder=" + sortOrder : "") +
            (exportRecords != -1 ? "&exportRecords=" + exportRecords : "");

        return this.makeGetCall(this.getOrdersShortSnippetNewUrl + param);
    }

    getFilteredCredilaOrdersPagination(
        partnerId,
        uiChannel,
        productGroup,
        status,
        paymentStatus,
        startDate,
        endDate,
        branchId,
        userId,
        pageNumber,
        recordPerPage,
        searchKeyword,
        sortField,
        sortOrder,
        exportRecords,
        colorCode,
    ) {
        if (
            (partnerId == null || partnerId == -1) &&
            (this.API_URL === "https://api.wsfx.in/" ||
                this.API_URL === "https://api.wsfxglobalpay.com/")
        ) {
            partnerId = "p_2sSBezBVhSH";
        } else {
            partnerId = "p_2HsvZhzZwXB";
        }

        let param =
            "?startDate=" +
            startDate +
            "&endDate=" +
            endDate +
            (partnerId != null ? "&partnerId=" + partnerId : "") +
            (uiChannel != -1 ? "&uiChannel=" + uiChannel : "") +
            (productGroup != -1 ? "&productGroup=" + productGroup : "") +
            (status != -1 ? "&status=" + status : "") +
            (paymentStatus != -1 ? "&paymentStatus=" + paymentStatus : "") +
            (branchId != -1 ? "&branchId=" + branchId : "") +
            (userId != -1 ? "&userId=" + userId : "") +
            (pageNumber != null ? "&pageNumber=" + pageNumber : "") +
            (recordPerPage != null ? "&recordPerPage=" + recordPerPage : "") +
            (searchKeyword != "" ? "&searchKeyword=" + searchKeyword : "") +
            (sortField != -1 ? "&sortField=" + sortField : "") +
            (sortOrder != -1 ? "&sortOrder=" + sortOrder : "") +
            (exportRecords != -1 ? "&exportRecords=" + exportRecords : "") +
            (colorCode != -1 ? "&colorCode=" + colorCode : "");

        return this.makeGetCall(this.getOrdersShortSnippetNewUrl + param);
    }

    getFilteredAd1OrdersPagination(
        partnerId,
        uiChannel,
        productGroup,
        status,
        paymentStatus,
        startDate,
        endDate,
        branchId,
        userId,
        pageNumber,
        recordPerPage,
        searchKeyword,
        sortField,
        sortOrder,
        exportRecords,
        colorCode,
    ) {
        let param =
            "?startDate=" +
            startDate +
            "&endDate=" +
            endDate +
            "&isAd1=true" +
            (partnerId != null ? "&partnerId=" + partnerId : "") +
            (uiChannel != -1 ? "&uiChannel=" + uiChannel : "") +
            (productGroup != -1 ? "&productGroup=" + productGroup : "") +
            (status != -1 ? "&status=" + status : "") +
            (paymentStatus != -1 ? "&paymentStatus=" + paymentStatus : "") +
            (branchId != -1 ? "&branchId=" + branchId : "") +
            (userId != -1 ? "&userId=" + userId : "") +
            (pageNumber != null ? "&pageNumber=" + pageNumber : "") +
            (recordPerPage != null ? "&recordPerPage=" + recordPerPage : "") +
            (searchKeyword != "" ? "&searchKeyword=" + searchKeyword : "") +
            (sortField != -1 ? "&sortField=" + sortField : "") +
            (sortOrder != -1 ? "&sortOrder=" + sortOrder : "") +
            (exportRecords != -1 ? "&exportRecords=" + exportRecords : "") +
            (colorCode != -1 ? "&colorCode=" + colorCode : "");

        return this.makeGetCall(this.getOrdersShortSnippetNewUrl + param);
    }

    getFilteredAd1OrdersForVerification(
        partnerId,
        uiChannel,
        productGroup,
        status,
        paymentStatus,
        startDate,
        endDate,
        branchId,
        userId,
        pageNumber,
        recordPerPage,
        searchKeyword,
        sortField,
        sortOrder,
        exportRecords,
        colorCode,
    ) {
        let param =
            "?startDate=" +
            startDate +
            "&endDate=" +
            endDate +
            "&isAd1=true" +
            (partnerId != null ? "&partnerId=" + partnerId : "") +
            (uiChannel != -1 ? "&uiChannel=" + uiChannel : "") +
            (productGroup != -1 ? "&productGroup=" + productGroup : "") +
            (status != -1 ? "&status=" + status : "") +
            (paymentStatus != -1 ? "&paymentStatus=" + paymentStatus : "") +
            (branchId != -1 ? "&branchId=" + branchId : "") +
            (userId != -1 ? "&userId=" + userId : "") +
            (pageNumber != null ? "&pageNumber=" + pageNumber : "") +
            (recordPerPage != null ? "&recordPerPage=" + recordPerPage : "") +
            (searchKeyword != "" ? "&searchKeyword=" + searchKeyword : "") +
            (sortField != -1 ? "&sortField=" + sortField : "") +
            (sortOrder != -1 ? "&sortOrder=" + sortOrder : "") +
            (exportRecords != -1 ? "&exportRecords=" + exportRecords : "") +
            (colorCode != -1 ? "&colorCode=" + colorCode : "") +
            "&dealStatus=MAPPED";
        return this.makeGetCall(this.getOrdersShortSnippetNewUrl + param);
    }

    getFilteredCredilaOrders(
        partnerId,
        uiChannel,
        productGroup,
        status,
        paymentStatus,
        startDate,
        endDate,
        branchId,
        userId,
    ) {
        if (
            (partnerId == null || partnerId == -1) &&
            this.API_URL === "https://apiqa.wsfx.in/"
        ) {
            partnerId = "p_2HsvZhzZwXB";
        } else if (
            (partnerId == null || partnerId == -1) &&
            (this.API_URL === "https://api.wsfx.in/" ||
                this.API_URL === "https://api.wsfxglobalpay.com/")
        ) {
            partnerId = "p_2sSBezBVhSH";
        }
        // console.log("apiurl++", this.baseProvider.API_URL);
        // partnerId = "p_2sSBezBVhSH";

        // if (partnerId == -1) {
        //     partnerId = "p_2HsvZhzZwXB";
        // }

        if (
            productGroup != -1 &&
            status != -1 &&
            branchId != -1 &&
            uiChannel != -1 &&
            userId != -1
        ) {
            const url: string =
                this.getOrdersShortSnippetUrl +
                "?partnerId=" +
                partnerId +
                "&productGroup=" +
                productGroup +
                "&status=" +
                status +
                "&branchId=" +
                branchId +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate +
                "&userId=" +
                userId +
                "&uiChannel=" +
                uiChannel;
            return this.makeGetCall(url);
        }
        if (
            productGroup != -1 &&
            paymentStatus != -1 &&
            branchId != -1 &&
            uiChannel != -1 &&
            userId != -1
        ) {
            const url: string =
                this.getOrdersShortSnippetUrl +
                "?partnerId=" +
                partnerId +
                "&productGroup=" +
                productGroup +
                "&paymentStatus=" +
                paymentStatus +
                "&branchId=" +
                branchId +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate +
                "&userId=" +
                userId +
                "&uiChannel=" +
                uiChannel;
            return this.makeGetCall(url);
        }

        if (
            userId != -1 &&
            branchId != -1 &&
            uiChannel != -1 &&
            productGroup != -1
        ) {
            const url: string =
                this.getOrdersShortSnippetUrl +
                "?partnerId=" +
                partnerId +
                "&userId=" +
                userId +
                "&branchId=" +
                branchId +
                "&uiChannel=" +
                uiChannel +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate +
                "&productGroup=" +
                productGroup;
            return this.makeGetCall(url);
        }

        if (userId != -1 && branchId != -1 && uiChannel != -1 && status != -1) {
            const url: string =
                this.getOrdersShortSnippetUrl +
                "?partnerId=" +
                partnerId +
                "&userId=" +
                userId +
                "&branchId=" +
                branchId +
                "&uiChannel=" +
                uiChannel +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate +
                "&status=" +
                status;
            return this.makeGetCall(url);
        }

        if (
            userId != -1 &&
            branchId != -1 &&
            uiChannel != -1 &&
            paymentStatus != -1
        ) {
            const url: string =
                this.getOrdersShortSnippetUrl +
                "?partnerId=" +
                partnerId +
                "&userId=" +
                userId +
                "&branchId=" +
                branchId +
                "&uiChannel=" +
                uiChannel +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate +
                "&paymentStatus=" +
                paymentStatus;
            return this.makeGetCall(url);
        }

        if (userId != -1 && branchId != -1 && productGroup != -1 && status != -1) {
            const url: string =
                this.getOrdersShortSnippetUrl +
                "?partnerId=" +
                partnerId +
                "&userId=" +
                userId +
                "&branchId=" +
                branchId +
                "&productGroup=" +
                productGroup +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate +
                "&status=" +
                status;
            return this.makeGetCall(url);
        } else if (
            userId != -1 &&
            branchId != -1 &&
            productGroup != -1 &&
            paymentStatus != -1
        ) {
            const url: string =
                this.getOrdersShortSnippetUrl +
                "?partnerId=" +
                partnerId +
                "&userId=" +
                userId +
                "&branchId=" +
                branchId +
                "&productGroup=" +
                productGroup +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate +
                "&paymentStatus=" +
                paymentStatus;
            return this.makeGetCall(url);
        } else if (status != -1 && branchId != -1 && uiChannel != -1) {
            const url: string =
                this.getOrdersShortSnippetUrl +
                "?partnerId=" +
                partnerId +
                "&status=" +
                status +
                "&branchId=" +
                branchId +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate +
                "&uiChannel=" +
                uiChannel;
            return this.makeGetCall(url);
        } else if (userId != -1 && branchId != -1 && uiChannel != -1) {
            const url: string =
                this.getOrdersShortSnippetUrl +
                "?partnerId=" +
                partnerId +
                "&userId=" +
                userId +
                "&branchId=" +
                branchId +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate +
                "&uiChannel=" +
                uiChannel;
            return this.makeGetCall(url);
        } else if (userId != -1 && branchId != -1 && productGroup != -1) {
            const url: string =
                this.getOrdersShortSnippetUrl +
                "?partnerId=" +
                partnerId +
                "&userId=" +
                userId +
                "&branchId=" +
                branchId +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate +
                "&productGroup=" +
                productGroup;
            return this.makeGetCall(url);
        } else if (userId != -1 && branchId != -1 && status != -1) {
            const url: string =
                this.getOrdersShortSnippetUrl +
                "?partnerId=" +
                partnerId +
                "&userId=" +
                userId +
                "&branchId=" +
                branchId +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate +
                "&status=" +
                status;
            return this.makeGetCall(url);
        } else if (userId != -1 && branchId != -1 && paymentStatus != -1) {
            const url: string =
                this.getOrdersShortSnippetUrl +
                "?partnerId=" +
                partnerId +
                "&userId=" +
                userId +
                "&branchId=" +
                branchId +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate +
                "&paymentStatus=" +
                paymentStatus;
            return this.makeGetCall(url);
        } else if (userId != -1 && uiChannel != -1 && productGroup != -1) {
            const url: string =
                this.getOrdersShortSnippetUrl +
                "?partnerId=" +
                partnerId +
                "&userId=" +
                userId +
                "&uiChannel=" +
                uiChannel +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate +
                "&productGroup=" +
                productGroup;
            return this.makeGetCall(url);
        } else if (productGroup != -1 && branchId != -1 && uiChannel != -1) {
            const url: string =
                this.getOrdersShortSnippetUrl +
                "?partnerId=" +
                partnerId +
                "&productGroup=" +
                productGroup +
                "&branchId=" +
                branchId +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate +
                "&uiChannel=" +
                uiChannel;
            return this.makeGetCall(url);
        } else if (productGroup != -1 && status != -1 && uiChannel != -1) {
            const url: string =
                this.getOrdersShortSnippetUrl +
                "?partnerId=" +
                partnerId +
                "&productGroup=" +
                productGroup +
                "&status=" +
                status +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate +
                "&uiChannel=" +
                uiChannel;
            return this.makeGetCall(url);
        } else if (productGroup != -1 && paymentStatus != -1 && uiChannel != -1) {
            const url: string =
                this.getOrdersShortSnippetUrl +
                "?partnerId=" +
                partnerId +
                "&productGroup=" +
                productGroup +
                "&paymentStatus=" +
                paymentStatus +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate +
                "&uiChannel=" +
                uiChannel;
            return this.makeGetCall(url);
        } else if (productGroup != -1 && status != -1) {
            const url: string =
                this.getOrdersShortSnippetUrl +
                "?partnerId=" +
                partnerId +
                "&productGroup=" +
                productGroup +
                "&status=" +
                status +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate;
            return this.makeGetCall(url);
        } else if (paymentStatus != -1 && status != -1) {
            const url: string =
                this.getOrdersShortSnippetUrl +
                "?partnerId=" +
                partnerId +
                "&paymentStatus=" +
                paymentStatus +
                "&status=" +
                status +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate;
            return this.makeGetCall(url);
        } else if (productGroup != -1 && paymentStatus != -1) {
            const url: string =
                this.getOrdersShortSnippetUrl +
                "?partnerId=" +
                partnerId +
                "&productGroup=" +
                productGroup +
                "&paymentStatus=" +
                paymentStatus +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate;
            return this.makeGetCall(url);
        } else if (productGroup != -1 && branchId != -1) {
            const url: string =
                this.getOrdersShortSnippetUrl +
                "?partnerId=" +
                partnerId +
                "&productGroup=" +
                productGroup +
                "&branchId=" +
                branchId +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate;
            return this.makeGetCall(url);
        } else if (productGroup != -1 && uiChannel != -1) {
            const url: string =
                this.getOrdersShortSnippetUrl +
                "?partnerId=" +
                partnerId +
                "&productGroup=" +
                productGroup +
                "&uiChannel=" +
                uiChannel +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate;
            return this.makeGetCall(url);
        } else if (status != -1 && branchId != -1) {
            const url: string =
                this.getOrdersShortSnippetUrl +
                "?partnerId=" +
                partnerId +
                "&status=" +
                status +
                "&branchId=" +
                branchId +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate;
            return this.makeGetCall(url);
        } else if (paymentStatus != -1 && branchId != -1) {
            const url: string =
                this.getOrdersShortSnippetUrl +
                "?partnerId=" +
                partnerId +
                "&paymentStatus=" +
                paymentStatus +
                "&branchId=" +
                branchId +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate;
            return this.makeGetCall(url);
        } else if (status != -1 && uiChannel != -1) {
            const url: string =
                this.getOrdersShortSnippetUrl +
                "?partnerId=" +
                partnerId +
                "&status=" +
                status +
                "&uiChannel=" +
                uiChannel +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate;
            return this.makeGetCall(url);
        } else if (paymentStatus != -1 && uiChannel != -1) {
            const url: string =
                this.getOrdersShortSnippetUrl +
                "?partnerId=" +
                partnerId +
                "&paymentStatus=" +
                paymentStatus +
                "&uiChannel=" +
                uiChannel +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate;
            return this.makeGetCall(url);
        } else if (userId != -1 && uiChannel != -1) {
            const url: string =
                this.getOrdersShortSnippetUrl +
                "?partnerId=" +
                partnerId +
                "&userId=" +
                userId +
                "&uiChannel=" +
                uiChannel +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate;
            return this.makeGetCall(url);
        } else if (userId != -1 && productGroup != -1) {
            const url: string =
                this.getOrdersShortSnippetUrl +
                "?partnerId=" +
                partnerId +
                "&userId=" +
                userId +
                "&productGroup=" +
                productGroup +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate;
            return this.makeGetCall(url);
        } else if (userId != -1 && branchId != -1) {
            const url: string =
                this.getOrdersShortSnippetUrl +
                "?partnerId=" +
                partnerId +
                "&userId=" +
                userId +
                "&branchId=" +
                branchId +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate;
            return this.makeGetCall(url);
        } else if (userId != -1 && status != -1) {
            const url: string =
                this.getOrdersShortSnippetUrl +
                "?partnerId=" +
                partnerId +
                "&userId=" +
                userId +
                "&status=" +
                status +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate;
            return this.makeGetCall(url);
        } else if (userId != -1 && paymentStatus != -1) {
            const url: string =
                this.getOrdersShortSnippetUrl +
                "?partnerId=" +
                partnerId +
                "&userId=" +
                userId +
                "&paymentStatus=" +
                paymentStatus +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate;
            return this.makeGetCall(url);
        } else if (branchId != -1 && uiChannel != -1) {
            const url: string =
                this.getOrdersShortSnippetUrl +
                "?partnerId=" +
                partnerId +
                "&branchId=" +
                branchId +
                "&uiChannel=" +
                uiChannel +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate;
            return this.makeGetCall(url);
        } else if (productGroup != -1) {
            const url: string =
                this.getOrdersShortSnippetUrl +
                "?partnerId=" +
                partnerId +
                "&productGroup=" +
                productGroup +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate;
            return this.makeGetCall(url);
        } else if (uiChannel != -1) {
            const url: string =
                this.getOrdersShortSnippetUrl +
                "?partnerId=" +
                partnerId +
                "&uiChannel=" +
                uiChannel +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate;
            return this.makeGetCall(url);
        } else if (status != -1) {
            const url: string =
                this.getOrdersShortSnippetUrl +
                "?partnerId=" +
                partnerId +
                "&status=" +
                status +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate;
            return this.makeGetCall(url);
        } else if (userId != -1) {
            const url: string =
                this.getOrdersShortSnippetUrl +
                "?partnerId=" +
                partnerId +
                "&userId=" +
                userId +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate;
            return this.makeGetCall(url);
        } else if (branchId != -1) {
            const url: string =
                this.getOrdersShortSnippetUrl +
                "?partnerId=" +
                partnerId +
                "&branchId=" +
                branchId +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate;
            return this.makeGetCall(url);
        } else if (paymentStatus != -1) {
            const url: string =
                this.getOrdersShortSnippetUrl +
                "?partnerId=" +
                partnerId +
                "&paymentStatus=" +
                paymentStatus +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate;
            return this.makeGetCall(url);
        } else {
            const url: string =
                this.getOrdersShortSnippetUrl +
                "?partnerId=" +
                partnerId +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate;
            return this.makeGetCall(url);
        }
    }
    getFilteredInsuranceOrders(paymentStatus, startDate, endDate) {
        const url: string =
            this.getInsuranceOrdersUrl +
            "?" +
            "&endDate=" +
            endDate +
            "&payment_status=" +
            paymentStatus +
            "&startDate=" +
            startDate;
        return this.makeGetCall(url);
    }
    getAllPendingOrders(partnerId, orderStatus, branchId) {
        if (partnerId == null) {
            partnerId = this._gs.currentUser.partner.id;
        }
        if (partnerId == -1) {
            partnerId = this._gs.currentUser.partner.id;
        }

        if (branchId != -1) {
            return this.makeGetCall(
                this.getOrdersShortSnippetUrl +
                "?partnerId=" +
                partnerId +
                "&branchId=" +
                branchId +
                "&status=" +
                orderStatus,
            );
        } else {
            return this.makeGetCall(
                this.getOrdersShortSnippetUrl +
                "?partnerId=" +
                partnerId +
                "&status=" +
                orderStatus,
            );
        }
    }
    getAllPendingCredilaOrders(partnerId, orderStatus, branchId) {
        // if (partnerId == null) {
        //     partnerId = "p_2HsvZhzZwXB";
        // }
        // if (partnerId == -1) {
        //     partnerId = "p_2HsvZhzZwXB";
        // }
        if (
            partnerId == null ||
            (partnerId == -1 && this.API_URL === "https://apiqa.wsfx.in/")
        ) {
            partnerId = "p_2HsvZhzZwXB";
        } else if (
            partnerId == null ||
            (partnerId == -1 &&
                (this.API_URL === "https://api.wsfx.in/" ||
                    this.API_URL === "https://api.wsfxglobalpay.com/"))
        ) {
            partnerId = "p_2sSBezBVhSH";
        }

        if (branchId != -1) {
            return this.makeGetCall(
                this.getOrdersShortSnippetUrl +
                "?partnerId=" +
                partnerId +
                "&branchId=" +
                branchId +
                "&status=" +
                orderStatus,
            );
        } else {
            return this.makeGetCall(
                this.getOrdersShortSnippetUrl +
                "?partnerId=" +
                partnerId +
                "&status=" +
                orderStatus,
            );
        }
    }
    getPartner() {
        // Fetch all Partner given the token
        return this.makeGetCall("partnersShortSnippet");
    }

    getAllOrderSnippets(branchId) {
        return this.makeGetCall(
            this.getOrdersSnippetUrl +
            "?partnerId=" +
            this._gs.currentUser.partner.id +
            "&branchId=" +
            branchId,
        );
    }

    getOrderShortSnippetsBranch(branchId) {
        return this.makeGetCall(
            this.getOrdersShortSnippetUrl +
            "?partnerId=" +
            this._gs.currentUser.partner.id +
            "&branchId=" +
            branchId,
        );
    }

    reUploadInvoice(orderId, formData) {
        return this.makeUploadCallPost(
            "orders/" + orderId + "/extInvoice",
            formData,
        );
    }

    getOrdersByConsumer(consumerId) {
        return this.makeGetCall(this.getOrdersUrl + "?consumerId=" + consumerId);
    }

    getCountries() {
        return this.makeGetCall("countries");
    }
    getPurposeWiseDocuments(product) {
        return this.makeGetCall("purposes?product=" + product);
    }
    cancelOrder() {
        return this.makeDeleteCall(
            this.getOrdersUrl + "/" + this._gs.order.orderId,
        );
    }

    getProductPurpose(partnerId) {
        return this.makeGetCall("productWisePurposes?partnerId=" + partnerId);
    }

    getOrderDetails(orderId: string) {
        let url = this.getOrderDetailsURL;
        url = url.replace("##ORDERID##", orderId);
        return this.makeGetCall(url);
    }
    getVisaRemittanceStatus(orderId: string) {
        let url = "orders/" + orderId + "/remittanceStatus";
        return this.makeGetCall(url);
    }
    remitPay(orderId: string) {
        let url = "remitPay/orderId?orderId=" + orderId;
        return this.makeGetCall(url);
    }
    visaRemitPaymentDetails(orderId: string) {
        let url = "visaRemitPaymentDetails/orderId?orderId=" + orderId;
        return this.makeGetCall(url);
    }
    getTransitionStatus(extTxnId: string, orderId: string) {
        let url =
            "visaRemitPaymentDetailsStatus/orderId?extTxnId=" +
            extTxnId +
            "&orderId=" +
            orderId;
        return this.makeGetCall(url);
    }
    getAllTransaction(orderId: string) {
        let url = "getRemitPaymentDetailsAllStatus/orderId?orderId=" + orderId;
        return this.makeGetCall(url);
    }
    getOfacDetails(orderId: string) {
        let url = "getFatfOfacDetails/" + orderId;
        return this.makeGetCall(url);
    }

    getOrderDetailsNew(orderId: string) {
        console.log("cacacac new", orderId);
        return this.makeGetCall("ordersConsodilated/" + orderId);
    }

    getOrderDetailsByToken(orderToken: string) {
        return this.makeGetCall("orderToken/" + orderToken);
    }
    getRemitLogs(orderId) {
        return this.makeGetCall("remitNowLogs?orderId=" + orderId);
    }
    getOrderStatus(status: string) {
        return this.makeGetCall(this.getOrderStatusUrl + "?status=" + status);
    }
    getRemitTransactions(orderId) {
        return this.makeGetCall("remitData?orderId=" + orderId);
    }
    postBulkOrders(orderRequest: any) {
        return this.makeUploadCall(this.postBulkOrdersURL, orderRequest);
    }
    addBulkOrders(uploadRequest: any) {
        return this.makeUploadCallPost("credilaBulkOrders", uploadRequest);
    }

    AddBulkOrdersAdmin(uploadRequest: any) {
        return this.makeUploadCallPost("bulkOrders", uploadRequest);
    }

    postOrderstoCartAdmin(orderRequest: any, consumeId, partnerId?) {
        if (partnerId == null) {
            partnerId = this._gs.currentUser.partner.id;
        }
        return this.makePostCall(
            "consumers/" +
            consumeId +
            "/partnerOrders?userId=" +
            this._gs.currentUser.id +
            "&partnerId=" +
            partnerId,
            orderRequest,
        );
    }

    postOrderstoCart(orderRequest: any, consumeId, partnerId?) {
        if (partnerId == null) {
            partnerId = this._gs.currentUser.partner.id;
        }
        let url = this.postOrdersUrl;
        url = url
            .replace("##CONSUMERID##", consumeId)
            .replace("##USERID##", this._gs.currentUser.id)
            .replace("##PARTNERID##", partnerId);

        return this.makePostCall(url, orderRequest);
    }
    postaadharFrontDetails(aadharFrontRequest: any) {
        return this.makePostCall(
            "doclocker/documents/aadharFrontDetails",
            aadharFrontRequest,
        );
    }
    getAadharFrontDetails(docId: string) {
        return this.makeGetCall("documentDetails/aadharFront/" + docId);
    }
    postaadharBackDetails(aadharBackRequest: any) {
        return this.makePostCall(
            "doclocker/documents/aadharBackDetails",
            aadharBackRequest,
        );
    }
    getAadharBackDetails(docId: string) {
        return this.makeGetCall("documentDetails/aadharBack/" + docId);
    }
    postChequeDetails(chequeRequest: any) {
        return this.makePostCall(
            "doclocker/documents/chequeDetails",
            chequeRequest,
        );
    }
    // getChequeDetails(chequeId: any) {
    //     return this.makeGetCall("doclocker/documents/postChequeDetails"+ chequeId);
    // }

    addManualPaymentTransaction(manualPaymentRequest: any) {
        return this.makePostCall("manualPayment", manualPaymentRequest);
    }

    initiatePaymentforOrder(paymentRequest: any) {
        return this.makePostCall(
            "payments?consumerId=" +
            paymentRequest.consumerId +
            "&orderId=" +
            paymentRequest.orderId,
            paymentRequest,
        );
    }
    getPaymentMethod() {
        return this.makeGetCall("collectionMethods", null);
    }
    getMDRCharges(orderId: any, paymentMode: any) {
        return this.makeGetCall(
            "generateInvoice/" + orderId + "?paymentMode=" + paymentMode,
            null,
        );
    }
    sendPaymentLink(orderId: any) {
        return this.makePostCall("payments/link", { orderId: orderId });
    }

    uploadBeneficiaryDocument(formData) {
        return this.makeUploadCallPost("updateBeneficiaryDocument", formData);
    }

    makePGCall(resourceURL: string) {
        this.addHeader("Content-Type", "application/x-www-form-urlencoded");
        // this.addHeader('clientid', 'spicefx');
        this.addHeader("channel", "web");
        this.addHeader(
            "Accept",
            "text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,image/apng,*/*;q=0.8",
        );
        window.open(resourceURL, "_self");
        return this.makeGetCall(resourceURL);
    }

    postDdDetails(dDRequest: any) {
        return this.makePostCall("doclocker/documents/ddDetails", dDRequest);
    }
    postPanCardDetails(panCardRequest: any) {
        return this.makePostCall(
            "doclocker/documents/panCardDetails",
            panCardRequest,
        );
    }
    getPanCardDetails(panCardId: any) {
        return this.makeGetCall("documentDetails/panCard/" + panCardId);
    }
    postPassportFrontDetails(passportFrontRequest: any) {
        return this.makePostCall(
            "doclocker/documents/passportFrontDetails",
            passportFrontRequest,
        );
    }
    getPassportFrontDetails(passportId: any) {
        return this.makeGetCall("documentDetails/passportFront/" + passportId);
    }
    postPassportBackDetails(passportBackRequest: any) {
        return this.makePostCall(
            "doclocker/documents/passportBackDetails",
            passportBackRequest,
        );
    }
    getPassportBackDetails(passportId: any) {
        return this.makeGetCall("documentDetails/passportBack/" + passportId);
    }

    getTransactionDocsForIDP(orderId) {
        return this.makeGetCall(
            "idp/std/totalVersusUploadedDocuments?orderId=" + orderId,
        );
    }

    getRelationshipList(consumerId) {
        var resourceUrl = "consumers/" + consumerId + "/pax";
        return this.makeGetCall(resourceUrl);
    }
    postUniversityFormDetails(universityFormRequest: any) {
        return this.makePostCall(
            "doclocker/documents/universityFormDetails",
            universityFormRequest,
        );
    }
    postDrivingLicenceDetails(drivingLicenceRequest: any) {
        return this.makePostCall(
            "doclocker/documents/drivingLicenceDetails",
            drivingLicenceRequest,
        );
    }
    getDrivingLicenceDetails(dlId: any) {
        return this.makeGetCall("documentDetails/drivingLicence/" + dlId);
    }
    postVoterIdDetails(voterIdRequest: any) {
        return this.makePostCall(
            "doclocker/documents/voterIdDetails",
            voterIdRequest,
        );
    }
    getVoterIdDetails(voterId: any) {
        return this.makeGetCall("documentDetails/voterId/" + voterId);
    }

    getOtherDocumentDetails(documentId: any) {
        return this.makeGetCall("documentDetails/others/" + documentId);
    }

    postOtherDocumentDetails(documentRequest: any) {
        return this.makePostCall(
            "doclocker/documents/otherDetails",
            documentRequest,
        );
    }
    // Get/Post Call For documentDetails End

    concludeRate(orderId) {
        let url = this.consludeRateURL;
        url = url.replace("##ORDERID##", orderId);
        return this.makePatchCall(url, {});
    }
    concludeOrder(orderId) {
        return this.makePatchCall("orders/" + orderId + "/push", {});
    }

    getReportSummary() {
        return this.makeGetCall("reports/processingSummery");
    }

    getBankReportSummary() {
        return this.makeGetCall("reports/bankProcessingStatus");
    }
    uploadSwift(imageData: any, orderId: any) {
        return this.makeUploadCall("orders/" + orderId + "/extSwift", imageData);
    }
    generateA2Form(orderId) {
        return this.makeGetCall("orders/" + orderId + "/generateA2");
    }
    getCustomerPaxes(customerId) {
        return this.makeGetCall("consumers/" + customerId + "/adminpaxes");
    }
    getCustomerVcip(customerId) {
        return this.makeGetCall("getVcipData/customer/" + customerId);
    }
    getCustomerById(customerId) {
        return this.makeGetCall("consumers/" + customerId);
    }
    getCustomerByOfferId(customerId) {
        return this.makeGetCall("admin/promoCodeFetchActive/" + customerId);
    }
    getCreditClaimHistory(customerId) {
        return this.makeGetCall("adminconsumerCreditClaimHistory/" + customerId);
    }
    getCreditCreditDetails(customerId) {
        return this.makeGetCall("adminConsumerCredits/" + customerId);
    }
    uploadA2Form(imageData: any, orderId: any) {
        return this.makeUploadCall("orders/" + orderId + "/signedA2", imageData);
    }
    uploadDocuments(imageData: any) {
        return this.makeUploadCall("doclocker/documents", imageData);
    }
    uploadTransactionProofDocuments(transactionId, imageData: any) {
        return this.makeUploadCallPost(
            "transactionProof?transactionId=" + transactionId,
            imageData,
        );
    }
    paxDocumentUploadUpdate(request: any) {
        return this.makeUploadCallPost("paxDocumentUploadUpdate", request);
    }

    deleteDocumentbyId(documentId: any) {
        return this.makeDeleteCall("doclocker/documents/" + documentId);
    }

    deleteDocumentFromOrder(orderId: any, documentId: any) {
        return this.makeDeleteCall(
            "orders/" + orderId + "/documents/?documentId=" + documentId,
        );
    }

    mapDocumentsToOrder(orderId, requestModel: any) {
        return this.makePostCall(
            this.getOrdersUrl + "/" + orderId + "/documents",
            requestModel,
        );
    }
    mapDocumentsPatch(documentId, DockType) {
        return this.makePatchCall("doclocker/documents/" + documentId, DockType);
    }

    getOrdersDetailsbyId(orderID) {
        return this.makeGetCall(this.getOrdersUrl + "/" + orderID, null);
    }
    // For KYC Details
    getkycDetails(orderID) {
        return this.makeGetCall(
            this.getkycDetailsUrl + "/initiatemanual?orderId=" + orderID,
            null,
        );
    }

    getWsflBranchesWithHOT() {
        return this.makeGetCall("wsflbranches?includeHOT=true", null);
    }

    getWsflBranches() {
        return this.makeGetCall("wsflbranches", null);
    }

    getCountryList() {
        return this.makeGetCall("countryList");
    }

    updateCountryList(countryList: any[]) {
        return this.makePatchCall("updateCountry", countryList);
    }

    getStates() {
        return this.makeGetCall("states", null);
    }
    getCities(stateId) {
        return this.makeGetCall("states/" + stateId + "/cities", null);
    }
    getkycMediums() {
        return this.makeGetCall(this.getkycDetailsUrl + "/mediums", null);
    }
    getTransactionDocuments(orderId) {
        var orderURL = "doclocker/totalVersusUploadedDocuments?orderId=" + orderId;

        return this.makeGetCall(orderURL);
    }
    getSignedA2Form(orderId) {
        return this.makeGetCall("a2FormDownload/" + orderId);
    }
    getEsignedDocument(orderRequest: any) {
        var orderUrl = "aadharEsignDocumentDetails";
        return this.makePostCall(orderUrl, orderRequest);
    }
    getTransactionProofDocument(consumerId, orderId) {
        var url = "transactions?consumerId=" + consumerId + "&orderId=" + orderId;
        return this.makeGetCall(url);
    }
    getTransactionDocumentsWithPurpose(purpose, product) {
        var orderURL =
            "doclocker/totalVersusUploadedDocuments?purpose=" +
            purpose +
            "&product=" +
            product;

        return this.makeGetCall(orderURL);
    }
    getUserList() {
        return this.makeGetCall("/users?scope=full", null);
    }
    createBeneficiary(consumerId, orderRequest: Array<OrderRequestModel>) {
        return this.makePostCall(
            "consumers/" +
            consumerId +
            "/orders" +
            "?consumerId=" +
            consumerId +
            "&partnerId=" +
            this._gs.currentUser.partner.id +
            "&userId=" +
            this._gs.currentUser.id,
            orderRequest,
        );
    }
    updateBeneficiary(orderId, orderRequest: any) {
        return this.makePatchCall(this.getOrderStatusUrl + orderId, orderRequest);
    }

    updatePax(orderId, orderRequest: any) {
        return this.makePatchCall(this.getOrderStatusUrl + orderId, orderRequest);
    }
    getComplianceRisk(orderId: string) {
        return this.makeGetCall("risk?orderId=" + orderId, null);
    }
    getAccounts(orderId) {
        return this.makeGetCall("ecollect/virtualAccounts" + "?ownerId=" + orderId);
    }
    getEmail(consumerId) {
        return this.makeGetCall(
            "doclocker/recepient" + "?consumerId=" + consumerId,
            null,
        );
    }
    patchOrderStatus(orderId, orderRequest) {
        return this.makePatchCall(
            this.getOrderStatusUrl + orderId + "/status",
            orderRequest,
        );
    }

    createPolicy(policyRequest) {
        return this.makePostCall("createNewPolicy", policyRequest);
    }

    getPolicy(insuranceOrderFormId) {
        return this.makeGetCall(
            "getPolicyDownload?insuranceOrderFormId=" + insuranceOrderFormId,
        );
    }

    getOrderSwift(orderId) {
        return this.makeGetCall("orders/" + orderId + "/extSwift");
    }
    postSwift(orderId, refNumber, swiftData: any) {
        return this.makeUploadCall(
            this.getOrdersUrl + "/" + orderId + "/extSwift",
            swiftData,
        );
    }
    getOrderInvoice(orderId) {
        return this.makeGetCall("orders/" + orderId + "/extInvoice");
    }
    postOrderInvoice(orderId, invoiceData: any) {
        return this.makeUploadCall(
            this.getOrdersUrl + "/" + orderId + "/extInvoice",
            invoiceData,
        );
    }

    getPanDetails(requestModel) {
        //Temp changing to uat
        // return this.makeGetCall("pan" + "?pan=" + requestModel);
        return this.makeGetCall("pan" + "?pan=" + requestModel);
    }
    getPanDetailsNSDL(requestModel) {
        //Temp changing to uat
        // return this.makeGetCall("pan" + "?pan=" + requestModel);
        return this.makeGetCall("panNsdl" + "?pan=" + requestModel);
    }
    verifyPan(pan, name, fatherName, dob) {
        return this.makeGetCall(
            "panV2?pan=" +
            pan +
            "&name=" +
            name +
            "&fatherName=" +
            fatherName +
            "&dob=" +
            dob,
        );
    }
    getTcsLoanProvider() {
        return this.makeGetCall("tcsLoanProvider");
    }
    vcipStatusChange(requestModel: any) {
        return this.makePostCall("consumer/statusChange", requestModel);
    }

    completeKyc(consumerId: string, comment: string) {
        return this.makePatchCall(
            `consumers/vcip?consumerId=${consumerId}&comment=${comment}`,
            {},
        );
    }
    getConsumerAuditTrails(consumerId) {
        return this.makeGetCall("consumerAuditTrails?consumerId=" + consumerId);
    }
    getBankAccountList(consumerId) {
        return this.makeGetCall("bankAccount?consumerId=" + consumerId);
    }
    getVcipStatus(consumerId) {
        return this.makeGetCall("getVcipStatus?consumerId=" + consumerId);
    }
    getOnBoardCustomer(consumerId) {
        return this.makeGetCall("onBoardCustomer?consumerId=" + consumerId);
    }
    getPaymentDetailsfromUtr(endDate, startDate, utr) {
        return this.makeGetCall(
            "getPaymentsDetails/fromUtr?endDate=" +
            endDate +
            "&startDate=" +
            startDate +
            "&utr=" +
            utr,
        );
    }
    getPaymentDetailsVirtualAccountId(consumerId) {
        return this.makeGetCall("getVirtualAccountDetails/" + consumerId);
    }
    getPaymentDetailsfromVirtualAccountId(endDate, startDate, virtualAccountId) {
        return this.makeGetCall(
            "getPaymentsDetails/fromVirtualAccountId?endDate=" +
            endDate +
            "&startDate=" +
            startDate +
            "&virtualAccountId=" +
            virtualAccountId,
        );
    }
    createVirtualAccount(virtualAccountRequest: createVirtualRequest) {
        return this.makePostCall("createVirtualAccount", virtualAccountRequest);
    }
    getCredilaOrderDetails(orderId) {
        return this.makeGetCall("credilaOrder/" + orderId);
    }

    postOrderCancellationMessage(orderId, cancellationMessage) {
        return this.makePostCall("cancelOrder/" + orderId, cancellationMessage);
    }

    reuploadEsignDocument(formData) {
        return this.makeUploadCallPost("eSignDocumentReUpload", formData);
    }

    getLogsData(id, startDate, endDate) {
        return this.makeGetCall(
            "getLogs?consumerId=" +
            id +
            "&startDate=" +
            startDate +
            "&endDate=" +
            endDate,
        );
    }

    getVkycDetails(customerId: any) {
        return this.makeGetCall("getVcipKycDetails?consumerId=" + customerId);
    }
    orderStatusChange(orderId: string, orderStatusChangeRequest: any) {
        return this.makePostCall(
            "changeOrderStatus/" + orderId,
            orderStatusChangeRequest,
        );
    }
    saveCompletionDate(data) {
        return this.makePostCall("remittanceDate", data);
    }
    sendOrderByEmail(consumerId, userId, partnerId, orders) {
        const status = "PENDING_CONSUMER_ACCEPTANCE";
        return this.makePostCall(
            "consumers/" +
            consumerId +
            "/orders?userId=" +
            userId +
            "&partnerId=" +
            partnerId +
            "&status=" +
            status,
            orders,
        );
    }
    sendQuote(consumerId, userId, partnerId, orders) {
        const status = "QUOTATION";
        return this.makePostCall(
            "consumers/" +
            consumerId +
            "/orders?userId=" +
            userId +
            "&partnerId=" +
            partnerId +
            "&status=" +
            status,
            orders,
        );
    }
    getTravelInsuranceOrdersList() {
        return this.makeGetCall("travelInsuranceGetOrders");
    }
    insuranceManualPayment(manualPaymentRequest: any) {
        return this.makePostCall("insuranceManualPayment", manualPaymentRequest);
    }
    getInsuranceOrderDetails(orderId) {
        return this.makeGetCall(
            "getcartTravelInsuranceOrder?insuranceOrderId=" + orderId,
        );
    }

    getExchangeBanks() {
        return this.makeGetCall("getExchangeBanks");
    }

    postCredilaOrderDetails(credilaOrdersRequest) {
        return this.makePostCall("createCredilaOrderDetails", credilaOrdersRequest);
    }

    postCredilaStudentDetails(credilaStudentRequest) {
        return this.makePostCall(
            "createCredilaStudentDetails",
            credilaStudentRequest,
        );
    }

    postCredilaCoApplicantDetails(credilaCoApplicantRequest) {
        return this.makePostCall(
            "createCredilaCoApplicantDetails",
            credilaCoApplicantRequest,
        );
    }

    postCredilaBeneficiaryDetails(credilaBeneRequest) {
        return this.makePostCall(
            "createCredilaBeneficiaryDetails",
            credilaBeneRequest,
        );
    }

    postCredilaTravelDetails(credilaTravelRequest) {
        return this.makePostCall(
            "createCredilaTravelDetails",
            credilaTravelRequest,
        );
    }

    concludeOrderForCredila(orderId) {
        return this.makePatchCall("orders/" + orderId + "/credilaConclude", {});
    }

    getCredilaOrder(orderId) {
        return this.makeGetCall("credilaQuoteOrder/" + orderId);
    }

    postDeliveryStart(orderId, kitId) {
        return this.makePostCall(
            "generateWaybill?orderId=" + orderId + "&kitId=" + kitId,
            {},
        );
    }

    getOrdersByConsumerAndDate(consumerId, startDate, endDate) {
        return this.makeGetCall(
            this.getOrdersUrl +
            "?consumerId=" +
            consumerId +
            "&startDate=" +
            startDate +
            "&endDate=" +
            endDate,
        );
    }

    generateManualCardForm(orderId) {
        return this.makeGetCall("b2c/manualCardForm?orderId=" + orderId);
    }

    getDepartments() {
        return this.makeGetCall(this.getDepartmentsUrl, null);
    }

    uploadIDFCBulkOrders(uploadRequest: any) {
        return this.makeUploadCallPost("createIdfcBulkOrders", uploadRequest);
    }

    remitIdfcOrder(refNumber: any) {
        return this.makePostCall("remitIdfcOrder?refNumber=" + refNumber, {});
    }

    postSwiftEmail(id) {
        return this.makePostCall("sendIdfcSwiftToConsumer?id=" + id, {});
    }

    postTrackShipment(orderId) {
        return this.makePostCall("trackShipment?orderId=" + orderId, {});
    }

    postReschedulePickup(awbNumber, kitId) {
        return this.makePostCall(
            "reschedulePickup?awb=" + awbNumber + "&kitId=" + kitId,
            {},
        );
    }

    getIdfcOrders(fromDate: string, toDate: string, status: string) {
        return this.makeGetCall(
            "getAllOrders?from=" +
            fromDate +
            "&to=" +
            toDate +
            (status && status != "" ? "&status=" + status : ""),
        );
    }

    getIDFCRemitStatus(refNumber: string) {
        return this.makeGetCall("getIdfcOrderStatus?refNumber=" + refNumber);
    }

    getIDFCOrdeSwift(orderId: any) {
        return this.makeGetCall("fetchSwiftAdvice?orderId=" + orderId);
    }

    getIDFCRemitLogs(refNumber: string) {
        return this.makeGetCall("getIdfcRemitAPILogs?orderId=" + refNumber);
    }

    postCancelIdfcOrder(orderId, message) {
        let req = {};
        return this.makePostCall(
            "cancelIdfcOrder?orderId=" + orderId + "&message=" + message,
            req,
        );
    }

    getIDFCOrderById(orderId: string) {
        return this.makeGetCall("getOrderById?id=" + orderId);
    }
    getFeeProfileByIssuer(issuerCode: string) {
        return this.makeGetCall(
            this.buildPrefixedUrl("feeProfiles?issuerCode=" + issuerCode),
        );
    }

    //update ibr rate
    updateIbrRate(orderId, customIbr) {
        return this.makePostCall(
            "order/updateWithCurrentRate?orderId=" +
            orderId +
            "&customIbr=" +
            customIbr,
            {},
        );
    }

    // DreamFolks Xplorer Membership ID
    requestXplorerMembershipId(kitId: string) {
        return this.makePostCall(
            "gp/getDreamFolksMembershipRetry?kitId=" + kitId,
            {},
        );
    }

    getXplorerMembershipDetails() {
        return this.makeGetCall("gp/getAllDreamFolksMembership");
    }
    getAncillaryOrdersDetails(ancillaryId) {
        const ancillaryorderUrl = `xplorerCard/${ancillaryId}`;
        return this.makeGetCall(ancillaryorderUrl);
    }

    searchXplorerMembership(searchKey: string) {
        return this.makeGetCall("gp/dreamfolks/search?search=" + searchKey);
    }

    getAllUsersTree() {
        return this.makeGetCall("credila/getAllUserTrees");
    }

    postUserTree(request) {
        return this.makePostCall("createCredilaUserTree", request);
    }

    getPartnersForUserTree() {
        return this.makeGetCall("getUniquePartnerIdList");
    }

    putEditUserTree(request) {
        return this.makePutCall("credila/updateUserTree", request);
    }
    getPassportDetailsForKIT(kitId) {
        return this.makeGetCall("gp/passportDetails?kit=" + kitId);
    }

    editPassportDetailsForKIT(kit, request) {
        return this.makePutCall("gp/passportDetails?kit=" + kit, request);
    }

    getFeeProfiles(issuerCode) {
        return this.makeGetCall("gp/feeProfiles?issuerCode=" + issuerCode);
    }

    editPromoCode(request) {
        return this.makePutCall("gp/feeProfiles", request);
    }
    sendEmailToFPAAS(request) {
        return this.makePostCall("requestConsumerOrderUpdate", request);
    }
    getBeneficiaryFieldList(currencyCode) {
        const url = `idp/cns/addBeneParameters?currencyCode=${currencyCode}`;
        return this.makeGetCall(url);
    }

    updateBranchAndUser(request) {
        return this.makePostCall("orderUserBranchUpdate", request);
    }
    postUpdateBankAccountStatus(bankAccountID, orderId, reBody) {
        return this.makePatchCall(
            "updateBankAccountStatus/" + bankAccountID + "?orderId=" + orderId,
            reBody,
        );
    }

    concludeOrderForXplorer(xplorerId) {
        return this.makePostCall("createCardActivationRequest/" + xplorerId, {});
    }

    reUploadInvoiceForXplorer(ancillaryOrderId, formData) {
        return this.makeUploadCallPost(
            "xplorerCard/uploadInvoiceUrl?xplorerId=" + ancillaryOrderId,
            formData,
        );
    }

    postOrderCancellationMessageForXplorer(xplorerId, message) {
        return this.makePutCall("xplorerCard/" + xplorerId + "/cancel", {
            message: message,
        });
    }

    checkQuotationLimitForINR(request) {
        return this.makePostCall("checkQuotationsLimitForINRAmount", request);
    }
}



// WEBPACK FOOTER //
// ./src/app/_services/order/order.service.ts